import { jsx as _t } from "react/jsx-runtime";
import * as i from "react";
import oe, { forwardRef as bt, useMemo as Go, useRef as De, useCallback as Re, useImperativeHandle as kn, useContext as $n, useState as kt, useEffect as zt, createContext as qo } from "react";
import "./_baseGetTag.js";
import "../theme/index.js";
import { u as Uo } from "./useMountedRef.js";
import { S as Yo } from "./dots-vertical.js";
import { isPureObject as Zo } from "../utils/misc/index.js";
import { _ as te } from "./extends.js";
import { I as ht } from "./AntdIcon.js";
import { P as _e, z as Hn, L as Xt, K as Ln, v as me, d as ae, n as V, c as Y, a3 as Qo, _ as re, R as Ee, w as ze, M as jn, I as Jo, J as er, b as tr, a as nr, y as or, q as rr, g as $t, u as _, C as Qe, an as ir, D as ar, A as lr, m as Ht, p as Cn, o as Kn, $ as yn, l as sr, h as Vn, B as In, j as cr, E as ur } from "./CSSMotionList.js";
import { T as Wn, a as dr } from "./roundedArrow.js";
import { K as ve } from "./KeyCode.js";
import { u as Ue } from "./useSize.js";
import { o as Ce } from "./omit.js";
import { u as Fn, z as mr } from "./Portal.js";
import { T as pr, g as fr, a as vr, b as gr } from "./index6.js";
import { g as br } from "./PurePanel.js";
import { c as Ct } from "./reactNode.js";
import { d as Xn } from "./warning.js";
import { i as Gn } from "./index.js";
import { i as hr, t as Gt, C as $r, a as qn, k as Cr, l as yr, u as Ir } from "./ContextIsolator.js";
import { F as Ye, i as ut, s as Sr, a as xr, b as wr, c as Er, d as Sn } from "./Overflow.js";
import { flushSync as Or } from "react-dom";
import { a as Mr, r as Nr } from "./mediaQueryUtil.js";
import { i as Un, a as Pr } from "./zoom.js";
import { g as Rr } from "./collapse.js";
import { B as dt } from "./button2.js";
var Br = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" }, Tr = function(n, t) {
  return /* @__PURE__ */ i.createElement(ht, te({}, n, {
    ref: t,
    icon: Br
  }));
}, mt = /* @__PURE__ */ i.forwardRef(Tr);
process.env.NODE_ENV !== "production" && (mt.displayName = "RightOutlined");
var Dr = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" }, _r = function(n, t) {
  return /* @__PURE__ */ i.createElement(ht, te({}, n, {
    ref: t,
    icon: Dr
  }));
}, pt = /* @__PURE__ */ i.forwardRef(_r);
process.env.NODE_ENV !== "production" && (pt.displayName = "LeftOutlined");
var zr = ve.ESC, Ar = ve.TAB;
function kr(e) {
  var n = e.visible, t = e.triggerRef, o = e.onVisibleChange, r = e.autoFocus, l = e.overlayRef, a = i.useRef(!1), s = function() {
    if (n) {
      var d, m;
      (d = t.current) === null || d === void 0 || (m = d.focus) === null || m === void 0 || m.call(d), o == null || o(!1);
    }
  }, c = function() {
    var d;
    return (d = l.current) !== null && d !== void 0 && d.focus ? (l.current.focus(), a.current = !0, !0) : !1;
  }, u = function(d) {
    switch (d.keyCode) {
      case zr:
        s();
        break;
      case Ar: {
        var m = !1;
        a.current || (m = c()), m ? d.preventDefault() : s();
        break;
      }
    }
  };
  i.useEffect(function() {
    return n ? (window.addEventListener("keydown", u), r && _e(c, 3), function() {
      window.removeEventListener("keydown", u), a.current = !1;
    }) : function() {
      a.current = !1;
    };
  }, [n]);
}
var Hr = /* @__PURE__ */ bt(function(e, n) {
  var t = e.overlay, o = e.arrow, r = e.prefixCls, l = Go(function() {
    var s;
    return typeof t == "function" ? s = t() : s = t, s;
  }, [t]), a = Hn(n, Xt(l));
  return /* @__PURE__ */ oe.createElement(oe.Fragment, null, o && /* @__PURE__ */ oe.createElement("div", {
    className: "".concat(r, "-arrow")
  }), /* @__PURE__ */ oe.cloneElement(l, {
    ref: Ln(l) ? a : void 0
  }));
}), Be = {
  adjustX: 1,
  adjustY: 1
}, Te = [0, 0], Lr = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: Be,
    offset: [0, -4],
    targetOffset: Te
  },
  top: {
    points: ["bc", "tc"],
    overflow: Be,
    offset: [0, -4],
    targetOffset: Te
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Be,
    offset: [0, -4],
    targetOffset: Te
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Be,
    offset: [0, 4],
    targetOffset: Te
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: Be,
    offset: [0, 4],
    targetOffset: Te
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Be,
    offset: [0, 4],
    targetOffset: Te
  }
}, jr = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function Kr(e, n) {
  var t, o = e.arrow, r = o === void 0 ? !1 : o, l = e.prefixCls, a = l === void 0 ? "rc-dropdown" : l, s = e.transitionName, c = e.animation, u = e.align, f = e.placement, d = f === void 0 ? "bottomLeft" : f, m = e.placements, g = m === void 0 ? Lr : m, p = e.getPopupContainer, v = e.showAction, h = e.hideAction, y = e.overlayClassName, w = e.overlayStyle, $ = e.visible, I = e.trigger, b = I === void 0 ? ["hover"] : I, S = e.autoFocus, x = e.overlay, E = e.children, C = e.onVisibleChange, O = me(e, jr), T = oe.useState(), P = ae(T, 2), B = P[0], M = P[1], N = "visible" in e ? $ : B, A = oe.useRef(null), k = oe.useRef(null), R = oe.useRef(null);
  oe.useImperativeHandle(n, function() {
    return A.current;
  });
  var H = function(D) {
    M(D), C == null || C(D);
  };
  kr({
    visible: N,
    triggerRef: R,
    onVisibleChange: H,
    autoFocus: S,
    overlayRef: k
  });
  var X = function(D) {
    var G = e.onOverlayClick;
    M(!1), G && G(D);
  }, ee = function() {
    return /* @__PURE__ */ oe.createElement(Hr, {
      ref: k,
      overlay: x,
      prefixCls: a,
      arrow: r
    });
  }, W = function() {
    return typeof x == "function" ? ee : ee();
  }, z = function() {
    var D = e.minOverlayWidthMatchTrigger, G = e.alignPoint;
    return "minOverlayWidthMatchTrigger" in e ? D : !G;
  }, F = function() {
    var D = e.openClassName;
    return D !== void 0 ? D : "".concat(a, "-open");
  }, L = /* @__PURE__ */ oe.cloneElement(E, {
    className: V((t = E.props) === null || t === void 0 ? void 0 : t.className, N && F()),
    ref: Ln(E) ? Hn(R, Xt(E)) : void 0
  }), j = h;
  return !j && b.indexOf("contextMenu") !== -1 && (j = ["click"]), /* @__PURE__ */ oe.createElement(Wn, te({
    builtinPlacements: g
  }, O, {
    prefixCls: a,
    ref: A,
    popupClassName: V(y, Y({}, "".concat(a, "-show-arrow"), r)),
    popupStyle: w,
    action: b,
    showAction: v,
    hideAction: j,
    popupPlacement: d,
    popupAlign: u,
    popupTransitionName: s,
    popupAnimation: c,
    popupVisible: N,
    stretch: z() ? "minWidth" : "",
    popup: W(),
    onPopupVisibleChange: H,
    onPopupClick: X,
    getPopupContainer: p
  }), L);
}
const Vr = /* @__PURE__ */ oe.forwardRef(Kr), Wr = (e) => typeof e != "object" && typeof e != "function" || e === null;
var Yn = /* @__PURE__ */ i.createContext(null);
function Zn(e, n) {
  return e === void 0 ? null : "".concat(e, "-").concat(n);
}
function Qn(e) {
  var n = i.useContext(Yn);
  return Zn(n, e);
}
var Fr = ["children", "locked"], fe = /* @__PURE__ */ i.createContext(null);
function Xr(e, n) {
  var t = re({}, e);
  return Object.keys(n).forEach(function(o) {
    var r = n[o];
    r !== void 0 && (t[o] = r);
  }), t;
}
function Ze(e) {
  var n = e.children, t = e.locked, o = me(e, Fr), r = i.useContext(fe), l = Qo(function() {
    return Xr(r, o);
  }, [r, o], function(a, s) {
    return !t && (a[0] !== s[0] || !Gn(a[1], s[1], !0));
  });
  return /* @__PURE__ */ i.createElement(fe.Provider, {
    value: l
  }, n);
}
var Gr = [], Jn = /* @__PURE__ */ i.createContext(null);
function yt() {
  return i.useContext(Jn);
}
var eo = /* @__PURE__ */ i.createContext(Gr);
function Ae(e) {
  var n = i.useContext(eo);
  return i.useMemo(function() {
    return e !== void 0 ? [].concat(Ee(n), [e]) : n;
  }, [n, e]);
}
var to = /* @__PURE__ */ i.createContext(null), qt = /* @__PURE__ */ i.createContext({});
function xn(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (hr(e)) {
    var t = e.nodeName.toLowerCase(), o = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(t) || // Editable element
      e.isContentEditable || // Anchor with href element
      t === "a" && !!e.getAttribute("href")
    ), r = e.getAttribute("tabindex"), l = Number(r), a = null;
    return r && !Number.isNaN(l) ? a = l : o && a === null && (a = 0), o && e.disabled && (a = null), a !== null && (a >= 0 || n && a < 0);
  }
  return !1;
}
function qr(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, t = Ee(e.querySelectorAll("*")).filter(function(o) {
    return xn(o, n);
  });
  return xn(e, n) && t.unshift(e), t;
}
var Lt = ve.LEFT, jt = ve.RIGHT, Kt = ve.UP, st = ve.DOWN, ct = ve.ENTER, no = ve.ESC, Xe = ve.HOME, Ge = ve.END, wn = [Kt, st, Lt, jt];
function Ur(e, n, t, o) {
  var r, l = "prev", a = "next", s = "children", c = "parent";
  if (e === "inline" && o === ct)
    return {
      inlineTrigger: !0
    };
  var u = Y(Y({}, Kt, l), st, a), f = Y(Y(Y(Y({}, Lt, t ? a : l), jt, t ? l : a), st, s), ct, s), d = Y(Y(Y(Y(Y(Y({}, Kt, l), st, a), ct, s), no, c), Lt, t ? s : c), jt, t ? c : s), m = {
    inline: u,
    horizontal: f,
    vertical: d,
    inlineSub: u,
    horizontalSub: d,
    verticalSub: d
  }, g = (r = m["".concat(e).concat(n ? "" : "Sub")]) === null || r === void 0 ? void 0 : r[o];
  switch (g) {
    case l:
      return {
        offset: -1,
        sibling: !0
      };
    case a:
      return {
        offset: 1,
        sibling: !0
      };
    case c:
      return {
        offset: -1,
        sibling: !1
      };
    case s:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function Yr(e) {
  for (var n = e; n; ) {
    if (n.getAttribute("data-menu-list"))
      return n;
    n = n.parentElement;
  }
  return null;
}
function Zr(e, n) {
  for (var t = e || document.activeElement; t; ) {
    if (n.has(t))
      return t;
    t = t.parentElement;
  }
  return null;
}
function Ut(e, n) {
  var t = qr(e, !0);
  return t.filter(function(o) {
    return n.has(o);
  });
}
function En(e, n, t) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!e)
    return null;
  var r = Ut(e, n), l = r.length, a = r.findIndex(function(s) {
    return t === s;
  });
  return o < 0 ? a === -1 ? a = l - 1 : a -= 1 : o > 0 && (a += 1), a = (a + l) % l, r[a];
}
var Vt = function(n, t) {
  var o = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
  return n.forEach(function(a) {
    var s = document.querySelector("[data-menu-id='".concat(Zn(t, a), "']"));
    s && (o.add(s), l.set(s, a), r.set(a, s));
  }), {
    elements: o,
    key2element: r,
    element2key: l
  };
};
function Qr(e, n, t, o, r, l, a, s, c, u) {
  var f = i.useRef(), d = i.useRef();
  d.current = n;
  var m = function() {
    _e.cancel(f.current);
  };
  return i.useEffect(function() {
    return function() {
      m();
    };
  }, []), function(g) {
    var p = g.which;
    if ([].concat(wn, [ct, no, Xe, Ge]).includes(p)) {
      var v = l(), h = Vt(v, o), y = h, w = y.elements, $ = y.key2element, I = y.element2key, b = $.get(n), S = Zr(b, w), x = I.get(S), E = Ur(e, a(x, !0).length === 1, t, p);
      if (!E && p !== Xe && p !== Ge)
        return;
      (wn.includes(p) || [Xe, Ge].includes(p)) && g.preventDefault();
      var C = function(k) {
        if (k) {
          var R = k, H = k.querySelector("a");
          H != null && H.getAttribute("href") && (R = H);
          var X = I.get(k);
          s(X), m(), f.current = _e(function() {
            d.current === X && R.focus();
          });
        }
      };
      if ([Xe, Ge].includes(p) || E.sibling || !S) {
        var O;
        !S || e === "inline" ? O = r.current : O = Yr(S);
        var T, P = Ut(O, w);
        p === Xe ? T = P[0] : p === Ge ? T = P[P.length - 1] : T = En(O, w, S, E.offset), C(T);
      } else if (E.inlineTrigger)
        c(x);
      else if (E.offset > 0)
        c(x, !0), m(), f.current = _e(function() {
          h = Vt(v, o);
          var A = S.getAttribute("aria-controls"), k = document.getElementById(A), R = En(k, h.elements);
          C(R);
        }, 5);
      else if (E.offset < 0) {
        var B = a(x, !0), M = B[B.length - 2], N = $.get(M);
        c(M, !1), C(N);
      }
    }
    u == null || u(g);
  };
}
function Jr(e) {
  Promise.resolve().then(e);
}
var Yt = "__RC_UTIL_PATH_SPLIT__", On = function(n) {
  return n.join(Yt);
}, ei = function(n) {
  return n.split(Yt);
}, Wt = "rc-menu-more";
function ti() {
  var e = i.useState({}), n = ae(e, 2), t = n[1], o = De(/* @__PURE__ */ new Map()), r = De(/* @__PURE__ */ new Map()), l = i.useState([]), a = ae(l, 2), s = a[0], c = a[1], u = De(0), f = De(!1), d = function() {
    f.current || t({});
  }, m = Re(function($, I) {
    process.env.NODE_ENV !== "production" && ze(!o.current.has($), "Duplicated key '".concat($, "' used in Menu by path [").concat(I.join(" > "), "]"));
    var b = On(I);
    r.current.set(b, $), o.current.set($, b), u.current += 1;
    var S = u.current;
    Jr(function() {
      S === u.current && d();
    });
  }, []), g = Re(function($, I) {
    var b = On(I);
    r.current.delete(b), o.current.delete($);
  }, []), p = Re(function($) {
    c($);
  }, []), v = Re(function($, I) {
    var b = o.current.get($) || "", S = ei(b);
    return I && s.includes(S[0]) && S.unshift(Wt), S;
  }, [s]), h = Re(function($, I) {
    return $.filter(function(b) {
      return b !== void 0;
    }).some(function(b) {
      var S = v(b, !0);
      return S.includes(I);
    });
  }, [v]), y = function() {
    var I = Ee(o.current.keys());
    return s.length && I.push(Wt), I;
  }, w = Re(function($) {
    var I = "".concat(o.current.get($)).concat(Yt), b = /* @__PURE__ */ new Set();
    return Ee(r.current.keys()).forEach(function(S) {
      S.startsWith(I) && b.add(r.current.get(S));
    }), b;
  }, []);
  return i.useEffect(function() {
    return function() {
      f.current = !0;
    };
  }, []), {
    // Register
    registerPath: m,
    unregisterPath: g,
    refreshOverflowKeys: p,
    // Util
    isSubPathKey: h,
    getKeyPath: v,
    getKeys: y,
    getSubPathKeys: w
  };
}
function qe(e) {
  var n = i.useRef(e);
  n.current = e;
  var t = i.useCallback(function() {
    for (var o, r = arguments.length, l = new Array(r), a = 0; a < r; a++)
      l[a] = arguments[a];
    return (o = n.current) === null || o === void 0 ? void 0 : o.call.apply(o, [n].concat(l));
  }, []);
  return e ? t : void 0;
}
var ni = Math.random().toFixed(5).toString().slice(2), Mn = 0;
function oi(e) {
  var n = Ue(e, {
    value: e
  }), t = ae(n, 2), o = t[0], r = t[1];
  return i.useEffect(function() {
    Mn += 1;
    var l = process.env.NODE_ENV === "test" ? "test" : "".concat(ni, "-").concat(Mn);
    r("rc-menu-uuid-".concat(l));
  }, []), o;
}
function oo(e, n, t, o) {
  var r = i.useContext(fe), l = r.activeKey, a = r.onActive, s = r.onInactive, c = {
    active: l === e
  };
  return n || (c.onMouseEnter = function(u) {
    t == null || t({
      key: e,
      domEvent: u
    }), a(e);
  }, c.onMouseLeave = function(u) {
    o == null || o({
      key: e,
      domEvent: u
    }), s(e);
  }), c;
}
function ro(e) {
  var n = i.useContext(fe), t = n.mode, o = n.rtl, r = n.inlineIndent;
  if (t !== "inline")
    return null;
  var l = e;
  return o ? {
    paddingRight: l * r
  } : {
    paddingLeft: l * r
  };
}
function io(e) {
  var n = e.icon, t = e.props, o = e.children, r;
  return n === null || n === !1 ? null : (typeof n == "function" ? r = /* @__PURE__ */ i.createElement(n, re({}, t)) : typeof n != "boolean" && (r = n), r || o || null);
}
var ri = ["item"];
function ft(e) {
  var n = e.item, t = me(e, ri);
  return Object.defineProperty(t, "item", {
    get: function() {
      return ze(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), n;
    }
  }), t;
}
var ii = ["title", "attribute", "elementRef"], ai = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], li = ["active"], si = /* @__PURE__ */ function(e) {
  Jo(t, e);
  var n = er(t);
  function t() {
    return tr(this, t), n.apply(this, arguments);
  }
  return nr(t, [{
    key: "render",
    value: function() {
      var r = this.props, l = r.title, a = r.attribute, s = r.elementRef, c = me(r, ii), u = Ce(c, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return ze(!a, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ i.createElement(Ye.Item, te({}, a, {
        title: typeof l == "string" ? l : void 0
      }, u, {
        ref: s
      }));
    }
  }]), t;
}(i.Component), ci = /* @__PURE__ */ i.forwardRef(function(e, n) {
  var t = e.style, o = e.className, r = e.eventKey, l = e.warnKey, a = e.disabled, s = e.itemIcon, c = e.children, u = e.role, f = e.onMouseEnter, d = e.onMouseLeave, m = e.onClick, g = e.onKeyDown, p = e.onFocus, v = me(e, ai), h = Qn(r), y = i.useContext(fe), w = y.prefixCls, $ = y.onItemClick, I = y.disabled, b = y.overflowDisabled, S = y.itemIcon, x = y.selectedKeys, E = y.onActive, C = i.useContext(qt), O = C._internalRenderMenuItem, T = "".concat(w, "-item"), P = i.useRef(), B = i.useRef(), M = I || a, N = jn(n, B), A = Ae(r);
  process.env.NODE_ENV !== "production" && l && ze(!1, "MenuItem should not leave undefined `key`.");
  var k = function(Q) {
    return {
      key: r,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: Ee(A).reverse(),
      item: P.current,
      domEvent: Q
    };
  }, R = s || S, H = oo(r, M, f, d), X = H.active, ee = me(H, li), W = x.includes(r), z = ro(A.length), F = function(Q) {
    if (!M) {
      var ne = k(Q);
      m == null || m(ft(ne)), $(ne);
    }
  }, L = function(Q) {
    if (g == null || g(Q), Q.which === ve.ENTER) {
      var ne = k(Q);
      m == null || m(ft(ne)), $(ne);
    }
  }, j = function(Q) {
    E(r), p == null || p(Q);
  }, Z = {};
  e.role === "option" && (Z["aria-selected"] = W);
  var D = /* @__PURE__ */ i.createElement(si, te({
    ref: P,
    elementRef: N,
    role: u === null ? "none" : u || "menuitem",
    tabIndex: a ? null : -1,
    "data-menu-id": b && h ? null : h
  }, Ce(v, ["extra"]), ee, Z, {
    component: "li",
    "aria-disabled": a,
    style: re(re({}, z), t),
    className: V(T, Y(Y(Y({}, "".concat(T, "-active"), X), "".concat(T, "-selected"), W), "".concat(T, "-disabled"), M), o),
    onClick: F,
    onKeyDown: L,
    onFocus: j
  }), c, /* @__PURE__ */ i.createElement(io, {
    props: re(re({}, e), {}, {
      isSelected: W
    }),
    icon: R
  }));
  return O && (D = O(D, e, {
    selected: W
  })), D;
});
function ui(e, n) {
  var t = e.eventKey, o = yt(), r = Ae(t);
  return i.useEffect(function() {
    if (o)
      return o.registerPath(t, r), function() {
        o.unregisterPath(t, r);
      };
  }, [r]), o ? null : /* @__PURE__ */ i.createElement(ci, te({}, e, {
    ref: n
  }));
}
const It = /* @__PURE__ */ i.forwardRef(ui);
var di = ["className", "children"], mi = function(n, t) {
  var o = n.className, r = n.children, l = me(n, di), a = i.useContext(fe), s = a.prefixCls, c = a.mode, u = a.rtl;
  return /* @__PURE__ */ i.createElement("ul", te({
    className: V(s, u && "".concat(s, "-rtl"), "".concat(s, "-sub"), "".concat(s, "-").concat(c === "inline" ? "inline" : "vertical"), o),
    role: "menu"
  }, l, {
    "data-menu-list": !0,
    ref: t
  }), r);
}, Zt = /* @__PURE__ */ i.forwardRef(mi);
Zt.displayName = "SubMenuList";
function Qt(e, n) {
  return Gt(e).map(function(t, o) {
    if (/* @__PURE__ */ i.isValidElement(t)) {
      var r, l, a = t.key, s = (r = (l = t.props) === null || l === void 0 ? void 0 : l.eventKey) !== null && r !== void 0 ? r : a, c = s == null;
      c && (s = "tmp_key-".concat([].concat(Ee(n), [o]).join("-")));
      var u = {
        key: s,
        eventKey: s
      };
      return process.env.NODE_ENV !== "production" && c && (u.warnKey = !0), /* @__PURE__ */ i.cloneElement(t, u);
    }
    return t;
  });
}
var le = {
  adjustX: 1,
  adjustY: 1
}, pi = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: le
  },
  topRight: {
    points: ["br", "tr"],
    overflow: le
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: le
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: le
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: le
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: le
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: le
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: le
  }
}, fi = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: le
  },
  topRight: {
    points: ["br", "tr"],
    overflow: le
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: le
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: le
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: le
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: le
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: le
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: le
  }
};
function ao(e, n, t) {
  if (n)
    return n;
  if (t)
    return t[e] || t.other;
}
var vi = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function gi(e) {
  var n = e.prefixCls, t = e.visible, o = e.children, r = e.popup, l = e.popupStyle, a = e.popupClassName, s = e.popupOffset, c = e.disabled, u = e.mode, f = e.onVisibleChange, d = i.useContext(fe), m = d.getPopupContainer, g = d.rtl, p = d.subMenuOpenDelay, v = d.subMenuCloseDelay, h = d.builtinPlacements, y = d.triggerSubMenuAction, w = d.forceSubMenuRender, $ = d.rootClassName, I = d.motion, b = d.defaultMotions, S = i.useState(!1), x = ae(S, 2), E = x[0], C = x[1], O = g ? re(re({}, fi), h) : re(re({}, pi), h), T = vi[u], P = ao(u, I, b), B = i.useRef(P);
  u !== "inline" && (B.current = P);
  var M = re(re({}, B.current), {}, {
    leavedClassName: "".concat(n, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), N = i.useRef();
  return i.useEffect(function() {
    return N.current = _e(function() {
      C(t);
    }), function() {
      _e.cancel(N.current);
    };
  }, [t]), /* @__PURE__ */ i.createElement(Wn, {
    prefixCls: n,
    popupClassName: V("".concat(n, "-popup"), Y({}, "".concat(n, "-rtl"), g), a, $),
    stretch: u === "horizontal" ? "minWidth" : null,
    getPopupContainer: m,
    builtinPlacements: O,
    popupPlacement: T,
    popupVisible: E,
    popup: r,
    popupStyle: l,
    popupAlign: s && {
      offset: s
    },
    action: c ? [] : [y],
    mouseEnterDelay: p,
    mouseLeaveDelay: v,
    onPopupVisibleChange: f,
    forceRender: w,
    popupMotion: M,
    fresh: !0
  }, o);
}
function bi(e) {
  var n = e.id, t = e.open, o = e.keyPath, r = e.children, l = "inline", a = i.useContext(fe), s = a.prefixCls, c = a.forceSubMenuRender, u = a.motion, f = a.defaultMotions, d = a.mode, m = i.useRef(!1);
  m.current = d === l;
  var g = i.useState(!m.current), p = ae(g, 2), v = p[0], h = p[1], y = m.current ? t : !1;
  i.useEffect(function() {
    m.current && h(!1);
  }, [d]);
  var w = re({}, ao(l, u, f));
  o.length > 1 && (w.motionAppear = !1);
  var $ = w.onVisibleChanged;
  return w.onVisibleChanged = function(I) {
    return !m.current && !I && h(!0), $ == null ? void 0 : $(I);
  }, v ? null : /* @__PURE__ */ i.createElement(Ze, {
    mode: l,
    locked: !m.current
  }, /* @__PURE__ */ i.createElement(or, te({
    visible: y
  }, w, {
    forceRender: c,
    removeOnLeave: !1,
    leavedClassName: "".concat(s, "-hidden")
  }), function(I) {
    var b = I.className, S = I.style;
    return /* @__PURE__ */ i.createElement(Zt, {
      id: n,
      className: b,
      style: S
    }, r);
  }));
}
var hi = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], $i = ["active"], Ci = /* @__PURE__ */ i.forwardRef(function(e, n) {
  var t = e.style, o = e.className, r = e.title, l = e.eventKey, a = e.warnKey, s = e.disabled, c = e.internalPopupClose, u = e.children, f = e.itemIcon, d = e.expandIcon, m = e.popupClassName, g = e.popupOffset, p = e.popupStyle, v = e.onClick, h = e.onMouseEnter, y = e.onMouseLeave, w = e.onTitleClick, $ = e.onTitleMouseEnter, I = e.onTitleMouseLeave, b = me(e, hi), S = Qn(l), x = i.useContext(fe), E = x.prefixCls, C = x.mode, O = x.openKeys, T = x.disabled, P = x.overflowDisabled, B = x.activeKey, M = x.selectedKeys, N = x.itemIcon, A = x.expandIcon, k = x.onItemClick, R = x.onOpenChange, H = x.onActive, X = i.useContext(qt), ee = X._internalRenderSubMenuItem, W = i.useContext(to), z = W.isSubPathKey, F = Ae(), L = "".concat(E, "-submenu"), j = T || s, Z = i.useRef(), D = i.useRef();
  process.env.NODE_ENV !== "production" && a && ze(!1, "SubMenu should not leave undefined `key`.");
  var G = f ?? N, Q = d ?? A, ne = O.includes(l), pe = !P && ne, Oe = z(M, l), he = oo(l, j, $, I), ge = he.active, He = me(he, $i), ye = i.useState(!1), U = ae(ye, 2), ue = U[0], Me = U[1], Le = function(de) {
    j || Me(de);
  }, xt = function(de) {
    Le(!0), h == null || h({
      key: l,
      domEvent: de
    });
  }, wt = function(de) {
    Le(!1), y == null || y({
      key: l,
      domEvent: de
    });
  }, je = i.useMemo(function() {
    return ge || (C !== "inline" ? ue || z([B], l) : !1);
  }, [C, ge, B, ue, l, z]), be = ro(F.length), Et = function(de) {
    j || (w == null || w({
      key: l,
      domEvent: de
    }), C === "inline" && R(l, !ne));
  }, Ot = qe(function(ie) {
    v == null || v(ft(ie)), k(ie);
  }), nt = function(de) {
    C !== "inline" && R(l, de);
  }, ot = function() {
    H(l);
  }, Ke = S && "".concat(S, "-popup"), Ne = i.useMemo(function() {
    return /* @__PURE__ */ i.createElement(io, {
      icon: C !== "horizontal" ? Q : void 0,
      props: re(re({}, e), {}, {
        isOpen: pe,
        // [Legacy] Not sure why need this mark
        isSubMenu: !0
      })
    }, /* @__PURE__ */ i.createElement("i", {
      className: "".concat(L, "-arrow")
    }));
  }, [C, Q, e, pe, L]), Ie = /* @__PURE__ */ i.createElement("div", te({
    role: "menuitem",
    style: be,
    className: "".concat(L, "-title"),
    tabIndex: j ? null : -1,
    ref: Z,
    title: typeof r == "string" ? r : null,
    "data-menu-id": P && S ? null : S,
    "aria-expanded": pe,
    "aria-haspopup": !0,
    "aria-controls": Ke,
    "aria-disabled": j,
    onClick: Et,
    onFocus: ot
  }, He), r, Ne), Se = i.useRef(C);
  if (C !== "inline" && F.length > 1 ? Se.current = "vertical" : Se.current = C, !P) {
    var Ve = Se.current;
    Ie = /* @__PURE__ */ i.createElement(gi, {
      mode: Ve,
      prefixCls: L,
      visible: !c && pe && C !== "inline",
      popupClassName: m,
      popupOffset: g,
      popupStyle: p,
      popup: /* @__PURE__ */ i.createElement(
        Ze,
        {
          mode: Ve === "horizontal" ? "vertical" : Ve
        },
        /* @__PURE__ */ i.createElement(Zt, {
          id: Ke,
          ref: D
        }, u)
      ),
      disabled: j,
      onVisibleChange: nt
    }, Ie);
  }
  var Pe = /* @__PURE__ */ i.createElement(Ye.Item, te({
    ref: n,
    role: "none"
  }, b, {
    component: "li",
    style: t,
    className: V(L, "".concat(L, "-").concat(C), o, Y(Y(Y(Y({}, "".concat(L, "-open"), pe), "".concat(L, "-active"), je), "".concat(L, "-selected"), Oe), "".concat(L, "-disabled"), j)),
    onMouseEnter: xt,
    onMouseLeave: wt
  }), Ie, !P && /* @__PURE__ */ i.createElement(bi, {
    id: Ke,
    open: pe,
    keyPath: F
  }, u));
  return ee && (Pe = ee(Pe, e, {
    selected: Oe,
    active: je,
    open: pe,
    disabled: j
  })), /* @__PURE__ */ i.createElement(Ze, {
    onItemClick: Ot,
    mode: C === "horizontal" ? "vertical" : C,
    itemIcon: G,
    expandIcon: Q
  }, Pe);
}), Je = /* @__PURE__ */ i.forwardRef(function(e, n) {
  var t = e.eventKey, o = e.children, r = Ae(t), l = Qt(o, r), a = yt();
  i.useEffect(function() {
    if (a)
      return a.registerPath(t, r), function() {
        a.unregisterPath(t, r);
      };
  }, [r]);
  var s;
  return a ? s = l : s = /* @__PURE__ */ i.createElement(Ci, te({
    ref: n
  }, e), l), /* @__PURE__ */ i.createElement(eo.Provider, {
    value: r
  }, s);
});
process.env.NODE_ENV !== "production" && (Je.displayName = "SubMenu");
function Jt(e) {
  var n = e.className, t = e.style, o = i.useContext(fe), r = o.prefixCls, l = yt();
  return l ? null : /* @__PURE__ */ i.createElement("li", {
    role: "separator",
    className: V("".concat(r, "-item-divider"), n),
    style: t
  });
}
var yi = ["className", "title", "eventKey", "children"], Ii = /* @__PURE__ */ i.forwardRef(function(e, n) {
  var t = e.className, o = e.title;
  e.eventKey;
  var r = e.children, l = me(e, yi), a = i.useContext(fe), s = a.prefixCls, c = "".concat(s, "-item-group");
  return /* @__PURE__ */ i.createElement("li", te({
    ref: n,
    role: "presentation"
  }, l, {
    onClick: function(f) {
      return f.stopPropagation();
    },
    className: V(c, t)
  }), /* @__PURE__ */ i.createElement("div", {
    role: "presentation",
    className: "".concat(c, "-title"),
    title: typeof o == "string" ? o : void 0
  }, o), /* @__PURE__ */ i.createElement("ul", {
    role: "group",
    className: "".concat(c, "-list")
  }, r));
}), St = /* @__PURE__ */ i.forwardRef(function(e, n) {
  var t = e.eventKey, o = e.children, r = Ae(t), l = Qt(o, r), a = yt();
  return a ? l : /* @__PURE__ */ i.createElement(Ii, te({
    ref: n
  }, Ce(e, ["warnKey"])), l);
});
process.env.NODE_ENV !== "production" && (St.displayName = "MenuItemGroup");
var Si = ["label", "children", "key", "type", "extra"];
function Ft(e, n, t) {
  var o = n.item, r = n.group, l = n.submenu, a = n.divider;
  return (e || []).map(function(s, c) {
    if (s && rr(s) === "object") {
      var u = s, f = u.label, d = u.children, m = u.key, g = u.type, p = u.extra, v = me(u, Si), h = m ?? "tmp-".concat(c);
      return d || g === "group" ? g === "group" ? /* @__PURE__ */ i.createElement(r, te({
        key: h
      }, v, {
        title: f
      }), Ft(d, n, t)) : /* @__PURE__ */ i.createElement(l, te({
        key: h
      }, v, {
        title: f
      }), Ft(d, n, t)) : g === "divider" ? /* @__PURE__ */ i.createElement(a, te({
        key: h
      }, v)) : /* @__PURE__ */ i.createElement(o, te({
        key: h
      }, v, {
        extra: p
      }), f, (!!p || p === 0) && /* @__PURE__ */ i.createElement("span", {
        className: "".concat(t, "-item-extra")
      }, p));
    }
    return null;
  }).filter(function(s) {
    return s;
  });
}
function Nn(e, n, t, o, r) {
  var l = e, a = re({
    divider: Jt,
    item: It,
    group: St,
    submenu: Je
  }, o);
  return n && (l = Ft(n, a, r)), Qt(l, t);
}
var xi = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"], we = [], wi = /* @__PURE__ */ i.forwardRef(function(e, n) {
  var t, o = e, r = o.prefixCls, l = r === void 0 ? "rc-menu" : r, a = o.rootClassName, s = o.style, c = o.className, u = o.tabIndex, f = u === void 0 ? 0 : u, d = o.items, m = o.children, g = o.direction, p = o.id, v = o.mode, h = v === void 0 ? "vertical" : v, y = o.inlineCollapsed, w = o.disabled, $ = o.disabledOverflow, I = o.subMenuOpenDelay, b = I === void 0 ? 0.1 : I, S = o.subMenuCloseDelay, x = S === void 0 ? 0.1 : S, E = o.forceSubMenuRender, C = o.defaultOpenKeys, O = o.openKeys, T = o.activeKey, P = o.defaultActiveFirst, B = o.selectable, M = B === void 0 ? !0 : B, N = o.multiple, A = N === void 0 ? !1 : N, k = o.defaultSelectedKeys, R = o.selectedKeys, H = o.onSelect, X = o.onDeselect, ee = o.inlineIndent, W = ee === void 0 ? 24 : ee, z = o.motion, F = o.defaultMotions, L = o.triggerSubMenuAction, j = L === void 0 ? "hover" : L, Z = o.builtinPlacements, D = o.itemIcon, G = o.expandIcon, Q = o.overflowedIndicator, ne = Q === void 0 ? "..." : Q, pe = o.overflowedIndicatorPopupClassName, Oe = o.getPopupContainer, he = o.onClick, ge = o.onOpenChange, He = o.onKeyDown, ye = o.openAnimation, U = o.openTransitionName, ue = o._internalRenderMenuItem, Me = o._internalRenderSubMenuItem, Le = o._internalComponents, xt = me(o, xi), wt = i.useMemo(function() {
    return [Nn(m, d, we, Le, l), Nn(m, d, we, {}, l)];
  }, [m, d, Le]), je = ae(wt, 2), be = je[0], Et = je[1], Ot = i.useState(!1), nt = ae(Ot, 2), ot = nt[0], Ke = nt[1], Ne = i.useRef(), Ie = oi(p), Se = g === "rtl";
  process.env.NODE_ENV !== "production" && ze(!ye && !U, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var Ve = Ue(C, {
    value: O,
    postState: function(K) {
      return K || we;
    }
  }), Pe = ae(Ve, 2), ie = Pe[0], de = Pe[1], Mt = function(K) {
    var q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function se() {
      de(K), ge == null || ge(K);
    }
    q ? Or(se) : se();
  }, bo = i.useState(ie), on = ae(bo, 2), ho = on[0], $o = on[1], Nt = i.useRef(!1), Co = i.useMemo(function() {
    return (h === "inline" || h === "vertical") && y ? ["vertical", y] : [h, !1];
  }, [h, y]), rn = ae(Co, 2), rt = rn[0], Pt = rn[1], an = rt === "inline", yo = i.useState(rt), ln = ae(yo, 2), $e = ln[0], Io = ln[1], So = i.useState(Pt), sn = ae(So, 2), xo = sn[0], wo = sn[1];
  i.useEffect(function() {
    Io(rt), wo(Pt), Nt.current && (an ? de(ho) : Mt(we));
  }, [rt, Pt]);
  var Eo = i.useState(0), cn = ae(Eo, 2), it = cn[0], Oo = cn[1], Rt = it >= be.length - 1 || $e !== "horizontal" || $;
  i.useEffect(function() {
    an && $o(ie);
  }, [ie]), i.useEffect(function() {
    return Nt.current = !0, function() {
      Nt.current = !1;
    };
  }, []);
  var xe = ti(), un = xe.registerPath, dn = xe.unregisterPath, Mo = xe.refreshOverflowKeys, mn = xe.isSubPathKey, No = xe.getKeyPath, pn = xe.getKeys, Po = xe.getSubPathKeys, Ro = i.useMemo(function() {
    return {
      registerPath: un,
      unregisterPath: dn
    };
  }, [un, dn]), Bo = i.useMemo(function() {
    return {
      isSubPathKey: mn
    };
  }, [mn]);
  i.useEffect(function() {
    Mo(Rt ? we : be.slice(it + 1).map(function(J) {
      return J.key;
    }));
  }, [it, Rt]);
  var To = Ue(T || P && ((t = be[0]) === null || t === void 0 ? void 0 : t.key), {
    value: T
  }), fn = ae(To, 2), We = fn[0], Bt = fn[1], Do = qe(function(J) {
    Bt(J);
  }), _o = qe(function() {
    Bt(void 0);
  });
  kn(n, function() {
    return {
      list: Ne.current,
      focus: function(K) {
        var q, se = pn(), ce = Vt(se, Ie), lt = ce.elements, Tt = ce.key2element, Fo = ce.element2key, bn = Ut(Ne.current, lt), hn = We ?? (bn[0] ? Fo.get(bn[0]) : (q = be.find(function(Xo) {
          return !Xo.props.disabled;
        })) === null || q === void 0 ? void 0 : q.key), Fe = Tt.get(hn);
        if (hn && Fe) {
          var Dt;
          Fe == null || (Dt = Fe.focus) === null || Dt === void 0 || Dt.call(Fe, K);
        }
      }
    };
  });
  var zo = Ue(k || [], {
    value: R,
    // Legacy convert key to array
    postState: function(K) {
      return Array.isArray(K) ? K : K == null ? we : [K];
    }
  }), vn = ae(zo, 2), at = vn[0], Ao = vn[1], ko = function(K) {
    if (M) {
      var q = K.key, se = at.includes(q), ce;
      A ? se ? ce = at.filter(function(Tt) {
        return Tt !== q;
      }) : ce = [].concat(Ee(at), [q]) : ce = [q], Ao(ce);
      var lt = re(re({}, K), {}, {
        selectedKeys: ce
      });
      se ? X == null || X(lt) : H == null || H(lt);
    }
    !A && ie.length && $e !== "inline" && Mt(we);
  }, Ho = qe(function(J) {
    he == null || he(ft(J)), ko(J);
  }), gn = qe(function(J, K) {
    var q = ie.filter(function(ce) {
      return ce !== J;
    });
    if (K)
      q.push(J);
    else if ($e !== "inline") {
      var se = Po(J);
      q = q.filter(function(ce) {
        return !se.has(ce);
      });
    }
    Gn(ie, q, !0) || Mt(q, !0);
  }), Lo = function(K, q) {
    var se = q ?? !ie.includes(K);
    gn(K, se);
  }, jo = Qr($e, We, Se, Ie, Ne, pn, No, Bt, Lo, He);
  i.useEffect(function() {
    Ke(!0);
  }, []);
  var Ko = i.useMemo(function() {
    return {
      _internalRenderMenuItem: ue,
      _internalRenderSubMenuItem: Me
    };
  }, [ue, Me]), Vo = $e !== "horizontal" || $ ? be : (
    // Need wrap for overflow dropdown that do not response for open
    be.map(function(J, K) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ i.createElement(Ze, {
          key: J.key,
          overflowDisabled: K > it
        }, J)
      );
    })
  ), Wo = /* @__PURE__ */ i.createElement(Ye, te({
    id: p,
    ref: Ne,
    prefixCls: "".concat(l, "-overflow"),
    component: "ul",
    itemComponent: It,
    className: V(l, "".concat(l, "-root"), "".concat(l, "-").concat($e), c, Y(Y({}, "".concat(l, "-inline-collapsed"), xo), "".concat(l, "-rtl"), Se), a),
    dir: g,
    style: s,
    role: "menu",
    tabIndex: f,
    data: Vo,
    renderRawItem: function(K) {
      return K;
    },
    renderRawRest: function(K) {
      var q = K.length, se = q ? be.slice(-q) : null;
      return /* @__PURE__ */ i.createElement(Je, {
        eventKey: Wt,
        title: ne,
        disabled: Rt,
        internalPopupClose: q === 0,
        popupClassName: pe
      }, se);
    },
    maxCount: $e !== "horizontal" || $ ? Ye.INVALIDATE : Ye.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(K) {
      Oo(K);
    },
    onKeyDown: jo
  }, xt));
  return /* @__PURE__ */ i.createElement(qt.Provider, {
    value: Ko
  }, /* @__PURE__ */ i.createElement(Yn.Provider, {
    value: Ie
  }, /* @__PURE__ */ i.createElement(Ze, {
    prefixCls: l,
    rootClassName: a,
    mode: $e,
    openKeys: ie,
    rtl: Se,
    disabled: w,
    motion: ot ? z : null,
    defaultMotions: ot ? F : null,
    activeKey: We,
    onActive: Do,
    onInactive: _o,
    selectedKeys: at,
    inlineIndent: W,
    subMenuOpenDelay: b,
    subMenuCloseDelay: x,
    forceSubMenuRender: E,
    builtinPlacements: Z,
    triggerSubMenuAction: j,
    getPopupContainer: Oe,
    itemIcon: D,
    expandIcon: G,
    onItemClick: Ho,
    onOpenChange: gn
  }, /* @__PURE__ */ i.createElement(to.Provider, {
    value: Bo
  }, Wo), /* @__PURE__ */ i.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ i.createElement(Jn.Provider, {
    value: Ro
  }, Et)))));
}), et = wi;
et.Item = It;
et.SubMenu = Je;
et.ItemGroup = St;
et.Divider = Jt;
var Ei = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "bars", theme: "outlined" }, Oi = function(n, t) {
  return /* @__PURE__ */ i.createElement(ht, te({}, n, {
    ref: t,
    icon: Ei
  }));
}, lo = /* @__PURE__ */ i.forwardRef(Oi);
process.env.NODE_ENV !== "production" && (lo.displayName = "BarsOutlined");
const Mi = /* @__PURE__ */ i.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
}), Ni = (e) => {
  const {
    antCls: n,
    // .ant
    componentCls: t,
    // .ant-layout
    colorText: o,
    footerBg: r,
    headerHeight: l,
    headerPadding: a,
    headerColor: s,
    footerPadding: c,
    fontSize: u,
    bodyBg: f,
    headerBg: d
  } = e;
  return {
    [t]: {
      display: "flex",
      flex: "auto",
      flexDirection: "column",
      /* fix firefox can't set height smaller than content on flex item */
      minHeight: 0,
      background: f,
      "&, *": {
        boxSizing: "border-box"
      },
      [`&${t}-has-sider`]: {
        flexDirection: "row",
        [`> ${t}, > ${t}-content`]: {
          // https://segmentfault.com/a/1190000019498300
          width: 0
        }
      },
      [`${t}-header, &${t}-footer`]: {
        flex: "0 0 auto"
      },
      // RTL
      "&-rtl": {
        direction: "rtl"
      }
    },
    // ==================== Header ====================
    [`${t}-header`]: {
      height: l,
      padding: a,
      color: s,
      lineHeight: _(l),
      background: d,
      // Other components/menu/style/index.less line:686
      // Integration with header element so menu items have the same height
      [`${n}-menu`]: {
        lineHeight: "inherit"
      }
    },
    // ==================== Footer ====================
    [`${t}-footer`]: {
      padding: c,
      color: o,
      fontSize: u,
      background: r
    },
    // =================== Content ====================
    [`${t}-content`]: {
      flex: "auto",
      color: o,
      // fix firefox can't set height smaller than content on flex item
      minHeight: 0
    }
  };
}, so = (e) => {
  const {
    colorBgLayout: n,
    controlHeight: t,
    controlHeightLG: o,
    colorText: r,
    controlHeightSM: l,
    marginXXS: a,
    colorTextLightSolid: s,
    colorBgContainer: c
  } = e, u = o * 1.25;
  return {
    // Deprecated
    colorBgHeader: "#001529",
    colorBgBody: n,
    colorBgTrigger: "#002140",
    bodyBg: n,
    headerBg: "#001529",
    headerHeight: t * 2,
    headerPadding: `0 ${u}px`,
    headerColor: r,
    footerPadding: `${l}px ${u}px`,
    footerBg: n,
    siderBg: "#001529",
    triggerHeight: o + a * 2,
    triggerBg: "#002140",
    triggerColor: s,
    zeroTriggerWidth: o,
    zeroTriggerHeight: o,
    lightSiderBg: c,
    lightTriggerBg: c,
    lightTriggerColor: r
  };
}, co = [["colorBgBody", "bodyBg"], ["colorBgHeader", "headerBg"], ["colorBgTrigger", "triggerBg"]];
$t("Layout", (e) => [Ni(e)], so, {
  deprecatedTokens: co
});
const Pi = (e) => {
  const {
    componentCls: n,
    siderBg: t,
    motionDurationMid: o,
    motionDurationSlow: r,
    antCls: l,
    triggerHeight: a,
    triggerColor: s,
    triggerBg: c,
    headerHeight: u,
    zeroTriggerWidth: f,
    zeroTriggerHeight: d,
    borderRadiusLG: m,
    lightSiderBg: g,
    lightTriggerColor: p,
    lightTriggerBg: v,
    bodyBg: h
  } = e;
  return {
    [n]: {
      position: "relative",
      // fix firefox can't set width smaller than content on flex item
      minWidth: 0,
      background: t,
      transition: `all ${o}, background 0s`,
      "&-has-trigger": {
        paddingBottom: a
      },
      "&-right": {
        order: 1
      },
      [`${n}-children`]: {
        height: "100%",
        // Hack for fixing margin collapse bug
        // https://github.com/ant-design/ant-design/issues/7967
        // solution from https://stackoverflow.com/a/33132624/3040605
        marginTop: -0.1,
        paddingTop: 0.1,
        [`${l}-menu${l}-menu-inline-collapsed`]: {
          width: "auto"
        }
      },
      [`&-zero-width ${n}-children`]: {
        overflow: "hidden"
      },
      [`${n}-trigger`]: {
        position: "fixed",
        bottom: 0,
        zIndex: 1,
        height: a,
        color: s,
        lineHeight: _(a),
        textAlign: "center",
        background: c,
        cursor: "pointer",
        transition: `all ${o}`
      },
      [`${n}-zero-width-trigger`]: {
        position: "absolute",
        top: u,
        insetInlineEnd: e.calc(f).mul(-1).equal(),
        zIndex: 1,
        width: f,
        height: d,
        color: s,
        fontSize: e.fontSizeXL,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: t,
        borderRadius: `0 ${_(m)} ${_(m)} 0`,
        cursor: "pointer",
        transition: `background ${r} ease`,
        "&::after": {
          position: "absolute",
          inset: 0,
          background: "transparent",
          transition: `all ${r}`,
          content: '""'
        },
        "&:hover::after": {
          background: "rgba(255, 255, 255, 0.2)"
        },
        "&-right": {
          insetInlineStart: e.calc(f).mul(-1).equal(),
          borderRadius: `${_(m)} 0 0 ${_(m)}`
        }
      },
      // Light
      "&-light": {
        background: g,
        [`${n}-trigger`]: {
          color: p,
          background: v
        },
        [`${n}-zero-width-trigger`]: {
          color: p,
          background: v,
          border: `1px solid ${h}`,
          // Safe to modify to any other color
          borderInlineStart: 0
        }
      }
    }
  };
}, Ri = $t(["Layout", "Sider"], (e) => [Pi(e)], so, {
  deprecatedTokens: co
});
var Bi = function(e, n) {
  var t = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (t[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
    n.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (t[o[r]] = e[o[r]]);
  return t;
};
const Pn = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
}, Ti = (e) => !Number.isNaN(Number.parseFloat(e)) && isFinite(e), en = /* @__PURE__ */ i.createContext({}), Di = /* @__PURE__ */ (() => {
  let e = 0;
  return (n = "") => (e += 1, `${n}${e}`);
})(), _i = /* @__PURE__ */ i.forwardRef((e, n) => {
  const {
    prefixCls: t,
    className: o,
    trigger: r,
    children: l,
    defaultCollapsed: a = !1,
    theme: s = "dark",
    style: c = {},
    collapsible: u = !1,
    reverseArrow: f = !1,
    width: d = 200,
    collapsedWidth: m = 80,
    zeroWidthTriggerStyle: g,
    breakpoint: p,
    onCollapse: v,
    onBreakpoint: h
  } = e, y = Bi(e, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]), {
    siderHook: w
  } = $n(Mi), [$, I] = kt("collapsed" in e ? e.collapsed : a), [b, S] = kt(!1);
  zt(() => {
    "collapsed" in e && I(e.collapsed);
  }, [e.collapsed]);
  const x = (D, G) => {
    "collapsed" in e || I(D), v == null || v(D, G);
  }, {
    getPrefixCls: E,
    direction: C
  } = $n(Qe), O = E("layout-sider", t), [T, P, B] = Ri(O), M = De(null);
  M.current = (D) => {
    S(D.matches), h == null || h(D.matches), $ !== D.matches && x(D.matches, "responsive");
  }, zt(() => {
    function D(Q) {
      var ne;
      return (ne = M.current) === null || ne === void 0 ? void 0 : ne.call(M, Q);
    }
    let G;
    return typeof (window == null ? void 0 : window.matchMedia) < "u" && p && p in Pn && (G = window.matchMedia(`screen and (max-width: ${Pn[p]})`), Mr(G, D), D(G)), () => {
      Nr(G, D);
    };
  }, [p]), zt(() => {
    const D = Di("ant-sider-");
    return w.addSider(D), () => w.removeSider(D);
  }, []);
  const N = () => {
    x(!$, "clickTrigger");
  }, A = Ce(y, ["collapsed"]), k = $ ? m : d, R = Ti(k) ? `${k}px` : String(k), H = parseFloat(String(m || 0)) === 0 ? /* @__PURE__ */ i.createElement("span", {
    onClick: N,
    className: V(`${O}-zero-width-trigger`, `${O}-zero-width-trigger-${f ? "right" : "left"}`),
    style: g
  }, r || /* @__PURE__ */ i.createElement(lo, null)) : null, X = C === "rtl" == !f, z = {
    expanded: X ? /* @__PURE__ */ i.createElement(mt, null) : /* @__PURE__ */ i.createElement(pt, null),
    collapsed: X ? /* @__PURE__ */ i.createElement(pt, null) : /* @__PURE__ */ i.createElement(mt, null)
  }[$ ? "collapsed" : "expanded"], F = r !== null ? H || /* @__PURE__ */ i.createElement("div", {
    className: `${O}-trigger`,
    onClick: N,
    style: {
      width: R
    }
  }, r || z) : null, L = Object.assign(Object.assign({}, c), {
    flex: `0 0 ${R}`,
    maxWidth: R,
    minWidth: R,
    width: R
  }), j = V(O, `${O}-${s}`, {
    [`${O}-collapsed`]: !!$,
    [`${O}-has-trigger`]: u && r !== null && !H,
    [`${O}-below`]: !!b,
    [`${O}-zero-width`]: parseFloat(R) === 0
  }, o, P, B), Z = i.useMemo(() => ({
    siderCollapsed: $
  }), [$]);
  return T(/* @__PURE__ */ i.createElement(en.Provider, {
    value: Z
  }, /* @__PURE__ */ i.createElement("aside", Object.assign({
    className: j
  }, A, {
    style: L,
    ref: n
  }), /* @__PURE__ */ i.createElement("div", {
    className: `${O}-children`
  }, l), u || b && H ? F : null)));
});
process.env.NODE_ENV !== "production" && (_i.displayName = "Sider");
var zi = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" }, Ai = function(n, t) {
  return /* @__PURE__ */ i.createElement(ht, te({}, n, {
    ref: t,
    icon: zi
  }));
}, tn = /* @__PURE__ */ i.forwardRef(Ai);
process.env.NODE_ENV !== "production" && (tn.displayName = "EllipsisOutlined");
const vt = /* @__PURE__ */ qo({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
});
var ki = function(e, n) {
  var t = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (t[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
    n.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (t[o[r]] = e[o[r]]);
  return t;
};
const uo = (e) => {
  const {
    prefixCls: n,
    className: t,
    dashed: o
  } = e, r = ki(e, ["prefixCls", "className", "dashed"]), {
    getPrefixCls: l
  } = i.useContext(Qe), a = l("menu", n), s = V({
    [`${a}-item-divider-dashed`]: !!o
  }, t);
  return /* @__PURE__ */ i.createElement(Jt, Object.assign({
    className: s
  }, r));
}, mo = (e) => {
  var n;
  const {
    className: t,
    children: o,
    icon: r,
    title: l,
    danger: a,
    extra: s
  } = e, {
    prefixCls: c,
    firstLevel: u,
    direction: f,
    disableMenuItemTitleTooltip: d,
    inlineCollapsed: m
  } = i.useContext(vt), g = ($) => {
    const I = o == null ? void 0 : o[0], b = /* @__PURE__ */ i.createElement("span", {
      className: V(`${c}-title-content`, {
        [`${c}-title-content-with-extra`]: !!s || s === 0
      })
    }, o);
    return (!r || /* @__PURE__ */ i.isValidElement(o) && o.type === "span") && o && $ && u && typeof I == "string" ? /* @__PURE__ */ i.createElement("div", {
      className: `${c}-inline-collapsed-noicon`
    }, I.charAt(0)) : b;
  }, {
    siderCollapsed: p
  } = i.useContext(en);
  let v = l;
  typeof l > "u" ? v = u ? o : "" : l === !1 && (v = "");
  const h = {
    title: v
  };
  !p && !m && (h.title = null, h.open = !1);
  const y = Gt(o).length;
  let w = /* @__PURE__ */ i.createElement(It, Object.assign({}, Ce(e, ["title", "icon", "danger"]), {
    className: V({
      [`${c}-item-danger`]: a,
      [`${c}-item-only-child`]: (r ? y + 1 : y) === 1
    }, t),
    title: typeof l == "string" ? l : void 0
  }), Ct(r, {
    className: V(/* @__PURE__ */ i.isValidElement(r) ? (n = r.props) === null || n === void 0 ? void 0 : n.className : "", `${c}-item-icon`)
  }), g(m));
  return d || (w = /* @__PURE__ */ i.createElement(pr, Object.assign({}, h, {
    placement: f === "rtl" ? "left" : "right",
    classNames: {
      root: `${c}-inline-collapsed-tooltip`
    }
  }), w)), w;
};
var Hi = function(e, n) {
  var t = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (t[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
    n.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (t[o[r]] = e[o[r]]);
  return t;
};
const gt = /* @__PURE__ */ i.createContext(null), Li = /* @__PURE__ */ i.forwardRef((e, n) => {
  const {
    children: t
  } = e, o = Hi(e, ["children"]), r = i.useContext(gt), l = i.useMemo(() => Object.assign(Object.assign({}, r), o), [
    r,
    o.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    o.mode,
    o.selectable,
    o.rootClassName
    // restProps.validator, Not mark as deps since this is a function
  ]), a = ir(t), s = jn(n, a ? Xt(t) : null);
  return /* @__PURE__ */ i.createElement(gt.Provider, {
    value: l
  }, /* @__PURE__ */ i.createElement($r, {
    space: !0
  }, a ? /* @__PURE__ */ i.cloneElement(t, {
    ref: s
  }) : t));
}), ji = (e) => {
  const {
    componentCls: n,
    motionDurationSlow: t,
    horizontalLineHeight: o,
    colorSplit: r,
    lineWidth: l,
    lineType: a,
    itemPaddingInline: s
  } = e;
  return {
    [`${n}-horizontal`]: {
      lineHeight: o,
      border: 0,
      borderBottom: `${_(l)} ${a} ${r}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${n}-item, ${n}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: s
      },
      [`> ${n}-item:hover,
        > ${n}-item-active,
        > ${n}-submenu ${n}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${n}-item, ${n}-submenu-title`]: {
        transition: [`border-color ${t}`, `background ${t}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${n}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, Ki = ({
  componentCls: e,
  menuArrowOffset: n,
  calc: t
}) => ({
  [`${e}-rtl`]: {
    direction: "rtl"
  },
  [`${e}-submenu-rtl`]: {
    transformOrigin: "100% 0"
  },
  // Vertical Arrow
  [`${e}-rtl${e}-vertical,
    ${e}-submenu-rtl ${e}-vertical`]: {
    [`${e}-submenu-arrow`]: {
      "&::before": {
        transform: `rotate(-45deg) translateY(${_(t(n).mul(-1).equal())})`
      },
      "&::after": {
        transform: `rotate(45deg) translateY(${_(n)})`
      }
    }
  }
}), Rn = (e) => Object.assign({}, ar(e)), Bn = (e, n) => {
  const {
    componentCls: t,
    itemColor: o,
    itemSelectedColor: r,
    subMenuItemSelectedColor: l,
    groupTitleColor: a,
    itemBg: s,
    subMenuItemBg: c,
    itemSelectedBg: u,
    activeBarHeight: f,
    activeBarWidth: d,
    activeBarBorderWidth: m,
    motionDurationSlow: g,
    motionEaseInOut: p,
    motionEaseOut: v,
    itemPaddingInline: h,
    motionDurationMid: y,
    itemHoverColor: w,
    lineType: $,
    colorSplit: I,
    // Disabled
    itemDisabledColor: b,
    // Danger
    dangerItemColor: S,
    dangerItemHoverColor: x,
    dangerItemSelectedColor: E,
    dangerItemActiveBg: C,
    dangerItemSelectedBg: O,
    // Bg
    popupBg: T,
    itemHoverBg: P,
    itemActiveBg: B,
    menuSubMenuBg: M,
    // Horizontal
    horizontalItemSelectedColor: N,
    horizontalItemSelectedBg: A,
    horizontalItemBorderRadius: k,
    horizontalItemHoverBg: R
  } = e;
  return {
    [`${t}-${n}, ${t}-${n} > ${t}`]: {
      color: o,
      background: s,
      [`&${t}-root:focus-visible`]: Object.assign({}, Rn(e)),
      // ======================== Item ========================
      [`${t}-item`]: {
        "&-group-title, &-extra": {
          color: a
        }
      },
      [`${t}-submenu-selected > ${t}-submenu-title`]: {
        color: l
      },
      [`${t}-item, ${t}-submenu-title`]: {
        color: o,
        [`&:not(${t}-item-disabled):focus-visible`]: Object.assign({}, Rn(e))
      },
      // Disabled
      [`${t}-item-disabled, ${t}-submenu-disabled`]: {
        color: `${b} !important`
      },
      // Hover
      [`${t}-item:not(${t}-item-selected):not(${t}-submenu-selected)`]: {
        [`&:hover, > ${t}-submenu-title:hover`]: {
          color: w
        }
      },
      [`&:not(${t}-horizontal)`]: {
        [`${t}-item:not(${t}-item-selected)`]: {
          "&:hover": {
            backgroundColor: P
          },
          "&:active": {
            backgroundColor: B
          }
        },
        [`${t}-submenu-title`]: {
          "&:hover": {
            backgroundColor: P
          },
          "&:active": {
            backgroundColor: B
          }
        }
      },
      // Danger - only Item has
      [`${t}-item-danger`]: {
        color: S,
        [`&${t}-item:hover`]: {
          [`&:not(${t}-item-selected):not(${t}-submenu-selected)`]: {
            color: x
          }
        },
        [`&${t}-item:active`]: {
          background: C
        }
      },
      [`${t}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${t}-item-selected`]: {
        color: r,
        // Danger
        [`&${t}-item-danger`]: {
          color: E
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${t}-item-selected`]: {
        backgroundColor: u,
        // Danger
        [`&${t}-item-danger`]: {
          backgroundColor: O
        }
      },
      [`&${t}-submenu > ${t}`]: {
        backgroundColor: M
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${t}-popup > ${t}`]: {
        backgroundColor: T
      },
      [`&${t}-submenu-popup > ${t}`]: {
        backgroundColor: T
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${t}-horizontal`]: Object.assign(Object.assign({}, n === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${t}-item, > ${t}-submenu`]: {
          top: m,
          marginTop: e.calc(m).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: k,
          "&::after": {
            position: "absolute",
            insetInline: h,
            bottom: 0,
            borderBottom: `${_(f)} solid transparent`,
            transition: `border-color ${g} ${p}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            background: R,
            "&::after": {
              borderBottomWidth: f,
              borderBottomColor: N
            }
          },
          "&-selected": {
            color: N,
            backgroundColor: A,
            "&:hover": {
              backgroundColor: A
            },
            "&::after": {
              borderBottomWidth: f,
              borderBottomColor: N
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${t}-root`]: {
        [`&${t}-inline, &${t}-vertical`]: {
          borderInlineEnd: `${_(m)} ${$} ${I}`
        }
      },
      // ======================== Inline ========================
      [`&${t}-inline`]: {
        // Sub
        [`${t}-sub${t}-inline`]: {
          background: c
        },
        [`${t}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${_(d)} solid ${r}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${y} ${v}`, `opacity ${y} ${v}`].join(","),
            content: '""'
          },
          // Danger
          [`&${t}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: E
            }
          }
        },
        [`${t}-selected, ${t}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${y} ${p}`, `opacity ${y} ${p}`].join(",")
          }
        }
      }
    }
  };
}, Tn = (e) => {
  const {
    componentCls: n,
    itemHeight: t,
    itemMarginInline: o,
    padding: r,
    menuArrowSize: l,
    marginXS: a,
    itemMarginBlock: s,
    itemWidth: c,
    itemPaddingInline: u
  } = e, f = e.calc(l).add(r).add(a).equal();
  return {
    [`${n}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${n}-item, ${n}-submenu-title`]: {
      height: t,
      lineHeight: _(t),
      paddingInline: u,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: o,
      marginBlock: s,
      width: c
    },
    [`> ${n}-item,
            > ${n}-submenu > ${n}-submenu-title`]: {
      height: t,
      lineHeight: _(t)
    },
    [`${n}-item-group-list ${n}-submenu-title,
            ${n}-submenu-title`]: {
      paddingInlineEnd: f
    }
  };
}, Vi = (e) => {
  const {
    componentCls: n,
    iconCls: t,
    itemHeight: o,
    colorTextLightSolid: r,
    dropdownWidth: l,
    controlHeightLG: a,
    motionEaseOut: s,
    paddingXL: c,
    itemMarginInline: u,
    fontSizeLG: f,
    motionDurationFast: d,
    motionDurationSlow: m,
    paddingXS: g,
    boxShadowSecondary: p,
    collapsedWidth: v,
    collapsedIconSize: h
  } = e, y = {
    height: o,
    lineHeight: _(o),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [n]: {
        "&-inline, &-vertical": Object.assign({
          [`&${n}-root`]: {
            boxShadow: "none"
          }
        }, Tn(e))
      },
      [`${n}-submenu-popup`]: {
        [`${n}-vertical`]: Object.assign(Object.assign({}, Tn(e)), {
          boxShadow: p
        })
      }
    },
    // Vertical only
    {
      [`${n}-submenu-popup ${n}-vertical${n}-sub`]: {
        minWidth: l,
        maxHeight: `calc(100vh - ${_(e.calc(a).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${n}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${n}-root`]: {
          [`${n}-item, ${n}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${m}`, `background ${m}`, `padding ${d} ${s}`].join(","),
            [`> ${n}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${n}-sub${n}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${n}-submenu > ${n}-submenu-title`]: y,
          [`& ${n}-item-group-title`]: {
            paddingInlineStart: c
          }
        },
        // >>>>> Item
        [`${n}-item`]: y
      }
    },
    // Inline Collapse Only
    {
      [`${n}-inline-collapsed`]: {
        width: v,
        [`&${n}-root`]: {
          [`${n}-item, ${n}-submenu ${n}-submenu-title`]: {
            [`> ${n}-inline-collapsed-noicon`]: {
              fontSize: f,
              textAlign: "center"
            }
          }
        },
        [`> ${n}-item,
          > ${n}-item-group > ${n}-item-group-list > ${n}-item,
          > ${n}-item-group > ${n}-item-group-list > ${n}-submenu > ${n}-submenu-title,
          > ${n}-submenu > ${n}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${_(e.calc(h).div(2).equal())} - ${_(u)})`,
          textOverflow: "clip",
          [`
            ${n}-submenu-arrow,
            ${n}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${n}-item-icon, ${t}`]: {
            margin: 0,
            fontSize: h,
            lineHeight: _(o),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${n}-item-icon, ${t}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${n}-item-icon, ${t}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: r
          }
        },
        [`${n}-item-group-title`]: Object.assign(Object.assign({}, lr), {
          paddingInline: g
        })
      }
    }
  ];
}, Dn = (e) => {
  const {
    componentCls: n,
    motionDurationSlow: t,
    motionDurationMid: o,
    motionEaseInOut: r,
    motionEaseOut: l,
    iconCls: a,
    iconSize: s,
    iconMarginInlineEnd: c
  } = e;
  return {
    // >>>>> Item
    [`${n}-item, ${n}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${t}`, `background ${t}`, `padding calc(${t} + 0.1s) ${r}`].join(","),
      [`${n}-item-icon, ${a}`]: {
        minWidth: s,
        fontSize: s,
        transition: [`font-size ${o} ${l}`, `margin ${t} ${r}`, `color ${t}`].join(","),
        "+ span": {
          marginInlineStart: c,
          opacity: 1,
          transition: [`opacity ${t} ${r}`, `margin ${t}`, `color ${t}`].join(",")
        }
      },
      [`${n}-item-icon`]: Object.assign({}, sr()),
      [`&${n}-item-only-child`]: {
        [`> ${a}, > ${n}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${n}-item-disabled, ${n}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important",
        cursor: "not-allowed",
        pointerEvents: "none"
      },
      [`> ${n}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, _n = (e) => {
  const {
    componentCls: n,
    motionDurationSlow: t,
    motionEaseInOut: o,
    borderRadius: r,
    menuArrowSize: l,
    menuArrowOffset: a
  } = e;
  return {
    [`${n}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: e.margin,
        width: l,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${t} ${o}, opacity ${t}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: e.calc(l).mul(0.6).equal(),
          height: e.calc(l).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius: r,
          transition: [`background ${t} ${o}`, `transform ${t} ${o}`, `top ${t} ${o}`, `color ${t} ${o}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${_(e.calc(a).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${_(a)})`
        }
      }
    }
  };
}, Wi = (e) => {
  const {
    antCls: n,
    componentCls: t,
    fontSize: o,
    motionDurationSlow: r,
    motionDurationMid: l,
    motionEaseInOut: a,
    paddingXS: s,
    padding: c,
    colorSplit: u,
    lineWidth: f,
    zIndexPopup: d,
    borderRadiusLG: m,
    subMenuItemBorderRadius: g,
    menuArrowSize: p,
    menuArrowOffset: v,
    lineType: h,
    groupTitleLineHeight: y,
    groupTitleFontSize: w
  } = e;
  return [
    // Misc
    {
      "": {
        [t]: Object.assign(Object.assign({}, Cn()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${t}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Kn(e)), Cn()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: o,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${r} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${t}-item`]: {
            flex: "none"
          }
        },
        [`${t}-item, ${t}-submenu, ${t}-submenu-title`]: {
          borderRadius: e.itemBorderRadius
        },
        [`${t}-item-group-title`]: {
          padding: `${_(s)} ${_(c)}`,
          fontSize: w,
          lineHeight: y,
          transition: `all ${r}`
        },
        [`&-horizontal ${t}-submenu`]: {
          transition: [`border-color ${r} ${a}`, `background ${r} ${a}`].join(",")
        },
        [`${t}-submenu, ${t}-submenu-inline`]: {
          transition: [`border-color ${r} ${a}`, `background ${r} ${a}`, `padding ${l} ${a}`].join(",")
        },
        [`${t}-submenu ${t}-sub`]: {
          cursor: "initial",
          transition: [`background ${r} ${a}`, `padding ${r} ${a}`].join(",")
        },
        [`${t}-title-content`]: {
          transition: `color ${r}`,
          "&-with-extra": {
            display: "inline-flex",
            alignItems: "center",
            width: "100%"
          },
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${n}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          },
          [`${t}-item-extra`]: {
            marginInlineStart: "auto",
            paddingInlineStart: e.padding
          }
        },
        [`${t}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${t}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: u,
          borderStyle: h,
          borderWidth: 0,
          borderTopWidth: f,
          marginBlock: f,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), Dn(e)), {
        [`${t}-item-group`]: {
          [`${t}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${t}-item, ${t}-submenu-title`]: {
              paddingInline: `${_(e.calc(o).mul(2).equal())} ${_(c)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: d,
            borderRadius: m,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${t}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: 0,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            },
            [`> ${t}`]: Object.assign(Object.assign(Object.assign({
              borderRadius: m
            }, Dn(e)), _n(e)), {
              [`${t}-item, ${t}-submenu > ${t}-submenu-title`]: {
                borderRadius: g
              },
              [`${t}-submenu-title::after`]: {
                transition: `transform ${r} ${a}`
              }
            })
          },
          "\n          &-placement-leftTop,\n          &-placement-bottomRight,\n          ": {
            transformOrigin: "100% 0"
          },
          "\n          &-placement-leftBottom,\n          &-placement-topRight,\n          ": {
            transformOrigin: "100% 100%"
          },
          "\n          &-placement-rightBottom,\n          &-placement-topLeft,\n          ": {
            transformOrigin: "0 100%"
          },
          "\n          &-placement-bottomLeft,\n          &-placement-rightTop,\n          ": {
            transformOrigin: "0 0"
          },
          "\n          &-placement-leftTop,\n          &-placement-leftBottom\n          ": {
            paddingInlineEnd: e.paddingXS
          },
          "\n          &-placement-rightTop,\n          &-placement-rightBottom\n          ": {
            paddingInlineStart: e.paddingXS
          },
          "\n          &-placement-topRight,\n          &-placement-topLeft\n          ": {
            paddingBottom: e.paddingXS
          },
          "\n          &-placement-bottomRight,\n          &-placement-bottomLeft\n          ": {
            paddingTop: e.paddingXS
          }
        }
      }), _n(e)), {
        [`&-inline-collapsed ${t}-submenu-arrow,
        &-inline ${t}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${_(v)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${_(e.calc(v).mul(-1).equal())})`
          }
        },
        [`${t}-submenu-open${t}-submenu-inline > ${t}-submenu-title > ${t}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${_(e.calc(p).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${_(e.calc(v).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${_(v)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${n}-layout-header`]: {
        [t]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, Fi = (e) => {
  var n, t, o;
  const {
    colorPrimary: r,
    colorError: l,
    colorTextDisabled: a,
    colorErrorBg: s,
    colorText: c,
    colorTextDescription: u,
    colorBgContainer: f,
    colorFillAlter: d,
    colorFillContent: m,
    lineWidth: g,
    lineWidthBold: p,
    controlItemBgActive: v,
    colorBgTextHover: h,
    controlHeightLG: y,
    lineHeight: w,
    colorBgElevated: $,
    marginXXS: I,
    padding: b,
    fontSize: S,
    controlHeightSM: x,
    fontSizeLG: E,
    colorTextLightSolid: C,
    colorErrorHover: O
  } = e, T = (n = e.activeBarWidth) !== null && n !== void 0 ? n : 0, P = (t = e.activeBarBorderWidth) !== null && t !== void 0 ? t : g, B = (o = e.itemMarginInline) !== null && o !== void 0 ? o : e.marginXXS, M = new yn(C).setA(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: e.zIndexPopupBase + 50,
    radiusItem: e.borderRadiusLG,
    itemBorderRadius: e.borderRadiusLG,
    radiusSubMenuItem: e.borderRadiusSM,
    subMenuItemBorderRadius: e.borderRadiusSM,
    colorItemText: c,
    itemColor: c,
    colorItemTextHover: c,
    itemHoverColor: c,
    colorItemTextHoverHorizontal: r,
    horizontalItemHoverColor: r,
    colorGroupTitle: u,
    groupTitleColor: u,
    colorItemTextSelected: r,
    itemSelectedColor: r,
    subMenuItemSelectedColor: r,
    colorItemTextSelectedHorizontal: r,
    horizontalItemSelectedColor: r,
    colorItemBg: f,
    itemBg: f,
    colorItemBgHover: h,
    itemHoverBg: h,
    colorItemBgActive: m,
    itemActiveBg: v,
    colorSubItemBg: d,
    subMenuItemBg: d,
    colorItemBgSelected: v,
    itemSelectedBg: v,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth: T,
    colorActiveBarHeight: p,
    activeBarHeight: p,
    colorActiveBarBorderSize: g,
    activeBarBorderWidth: P,
    // Disabled
    colorItemTextDisabled: a,
    itemDisabledColor: a,
    // Danger
    colorDangerItemText: l,
    dangerItemColor: l,
    colorDangerItemTextHover: l,
    dangerItemHoverColor: l,
    colorDangerItemTextSelected: l,
    dangerItemSelectedColor: l,
    colorDangerItemBgActive: s,
    dangerItemActiveBg: s,
    colorDangerItemBgSelected: s,
    dangerItemSelectedBg: s,
    itemMarginInline: B,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: y,
    groupTitleLineHeight: w,
    collapsedWidth: y * 2,
    popupBg: $,
    itemMarginBlock: I,
    itemPaddingInline: b,
    horizontalLineHeight: `${y * 1.15}px`,
    iconSize: S,
    iconMarginInlineEnd: x - S,
    collapsedIconSize: E,
    groupTitleFontSize: S,
    // Disabled
    darkItemDisabledColor: new yn(C).setA(0.25).toRgbString(),
    // Dark
    darkItemColor: M,
    darkDangerItemColor: l,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: C,
    darkItemSelectedBg: r,
    darkDangerItemSelectedBg: l,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: M,
    darkItemHoverColor: C,
    darkDangerItemHoverColor: O,
    darkDangerItemSelectedColor: C,
    darkDangerItemActiveBg: l,
    // internal
    itemWidth: T ? `calc(100% + ${P}px)` : `calc(100% - ${B * 2}px)`
  };
}, Xi = (e, n = e, t = !0) => $t("Menu", (r) => {
  const {
    colorBgElevated: l,
    controlHeightLG: a,
    fontSize: s,
    darkItemColor: c,
    darkDangerItemColor: u,
    darkItemBg: f,
    darkSubMenuItemBg: d,
    darkItemSelectedColor: m,
    darkItemSelectedBg: g,
    darkDangerItemSelectedBg: p,
    darkItemHoverBg: v,
    darkGroupTitleColor: h,
    darkItemHoverColor: y,
    darkItemDisabledColor: w,
    darkDangerItemHoverColor: $,
    darkDangerItemSelectedColor: I,
    darkDangerItemActiveBg: b,
    popupBg: S,
    darkPopupBg: x
  } = r, E = r.calc(s).div(7).mul(5).equal(), C = Ht(r, {
    menuArrowSize: E,
    menuHorizontalHeight: r.calc(a).mul(1.15).equal(),
    menuArrowOffset: r.calc(E).mul(0.25).equal(),
    menuSubMenuBg: l,
    calc: r.calc,
    popupBg: S
  }), O = Ht(C, {
    itemColor: c,
    itemHoverColor: y,
    groupTitleColor: h,
    itemSelectedColor: m,
    subMenuItemSelectedColor: m,
    itemBg: f,
    popupBg: x,
    subMenuItemBg: d,
    itemActiveBg: "transparent",
    itemSelectedBg: g,
    activeBarHeight: 0,
    activeBarBorderWidth: 0,
    itemHoverBg: v,
    // Disabled
    itemDisabledColor: w,
    // Danger
    dangerItemColor: u,
    dangerItemHoverColor: $,
    dangerItemSelectedColor: I,
    dangerItemActiveBg: b,
    dangerItemSelectedBg: p,
    menuSubMenuBg: d,
    // Horizontal
    horizontalItemSelectedColor: m,
    horizontalItemSelectedBg: g
  });
  return [
    // Basic
    Wi(C),
    // Horizontal
    ji(C),
    // Hard code for some light style
    // Vertical
    Vi(C),
    // Hard code for some light style
    // Theme
    Bn(C, "light"),
    Bn(O, "dark"),
    // RTL
    Ki(C),
    // Motion
    Rr(C),
    ut(C, "slide-up"),
    ut(C, "slide-down"),
    Un(C, "zoom-big")
  ];
}, Fi, {
  deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
  // Dropdown will handle menu style self. We do not need to handle this.
  injectStyle: t,
  unitless: {
    groupTitleLineHeight: !0
  }
})(e, n), po = (e) => {
  var n;
  const {
    popupClassName: t,
    icon: o,
    title: r,
    theme: l
  } = e, a = i.useContext(vt), {
    prefixCls: s,
    inlineCollapsed: c,
    theme: u
  } = a, f = Ae();
  let d;
  if (!o)
    d = c && !f.length && r && typeof r == "string" ? /* @__PURE__ */ i.createElement("div", {
      className: `${s}-inline-collapsed-noicon`
    }, r.charAt(0)) : /* @__PURE__ */ i.createElement("span", {
      className: `${s}-title-content`
    }, r);
  else {
    const p = /* @__PURE__ */ i.isValidElement(r) && r.type === "span";
    d = /* @__PURE__ */ i.createElement(i.Fragment, null, Ct(o, {
      className: V(/* @__PURE__ */ i.isValidElement(o) ? (n = o.props) === null || n === void 0 ? void 0 : n.className : "", `${s}-item-icon`)
    }), p ? r : /* @__PURE__ */ i.createElement("span", {
      className: `${s}-title-content`
    }, r));
  }
  const m = i.useMemo(() => Object.assign(Object.assign({}, a), {
    firstLevel: !1
  }), [a]), [g] = Fn("Menu");
  return /* @__PURE__ */ i.createElement(vt.Provider, {
    value: m
  }, /* @__PURE__ */ i.createElement(Je, Object.assign({}, Ce(e, ["icon"]), {
    title: d,
    popupClassName: V(s, t, `${s}-${l || u}`),
    popupStyle: Object.assign({
      zIndex: g
    }, e.popupStyle)
  })));
};
var Gi = function(e, n) {
  var t = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (t[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
    n.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (t[o[r]] = e[o[r]]);
  return t;
};
function At(e) {
  return e === null || e === !1;
}
const qi = {
  item: mo,
  submenu: po,
  divider: uo
}, Ui = /* @__PURE__ */ bt((e, n) => {
  var t;
  const o = i.useContext(gt), r = o || {}, {
    getPrefixCls: l,
    getPopupContainer: a,
    direction: s,
    menu: c
  } = i.useContext(Qe), u = l(), {
    prefixCls: f,
    className: d,
    style: m,
    theme: g = "light",
    expandIcon: p,
    _internalDisableMenuItemTitleTooltip: v,
    inlineCollapsed: h,
    siderCollapsed: y,
    rootClassName: w,
    mode: $,
    selectable: I,
    onClick: b,
    overflowedIndicatorPopupClassName: S
  } = e, x = Gi(e, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]), E = Ce(x, ["collapsedWidth"]);
  if (process.env.NODE_ENV !== "production") {
    const W = Xn("Menu");
    process.env.NODE_ENV !== "production" && W(!("inlineCollapsed" in e && $ !== "inline"), "usage", "`inlineCollapsed` should only be used when `mode` is inline."), W.deprecated("items" in e && !e.children, "children", "items");
  }
  (t = r.validator) === null || t === void 0 || t.call(r, {
    mode: $
  });
  const C = Vn((...W) => {
    var z;
    b == null || b.apply(void 0, W), (z = r.onClick) === null || z === void 0 || z.call(r);
  }), O = r.mode || $, T = I ?? r.selectable, P = h ?? y, B = {
    horizontal: {
      motionName: `${u}-slide-up`
    },
    inline: Pr(u),
    other: {
      motionName: `${u}-zoom-big`
    }
  }, M = l("menu", f || r.prefixCls), N = qn(M), [A, k, R] = Xi(M, N, !o), H = V(`${M}-${g}`, c == null ? void 0 : c.className, d), X = i.useMemo(() => {
    var W, z;
    if (typeof p == "function" || At(p))
      return p || null;
    if (typeof r.expandIcon == "function" || At(r.expandIcon))
      return r.expandIcon || null;
    if (typeof (c == null ? void 0 : c.expandIcon) == "function" || At(c == null ? void 0 : c.expandIcon))
      return (c == null ? void 0 : c.expandIcon) || null;
    const F = (W = p ?? (r == null ? void 0 : r.expandIcon)) !== null && W !== void 0 ? W : c == null ? void 0 : c.expandIcon;
    return Ct(F, {
      className: V(`${M}-submenu-expand-icon`, /* @__PURE__ */ i.isValidElement(F) ? (z = F.props) === null || z === void 0 ? void 0 : z.className : void 0)
    });
  }, [p, r == null ? void 0 : r.expandIcon, c == null ? void 0 : c.expandIcon, M]), ee = i.useMemo(() => ({
    prefixCls: M,
    inlineCollapsed: P || !1,
    direction: s,
    firstLevel: !0,
    theme: g,
    mode: O,
    disableMenuItemTitleTooltip: v
  }), [M, P, s, v, g]);
  return A(/* @__PURE__ */ i.createElement(gt.Provider, {
    value: null
  }, /* @__PURE__ */ i.createElement(vt.Provider, {
    value: ee
  }, /* @__PURE__ */ i.createElement(et, Object.assign({
    getPopupContainer: a,
    overflowedIndicator: /* @__PURE__ */ i.createElement(tn, null),
    overflowedIndicatorPopupClassName: V(M, `${M}-${g}`, S),
    mode: O,
    selectable: T,
    onClick: C
  }, E, {
    inlineCollapsed: P,
    style: Object.assign(Object.assign({}, c == null ? void 0 : c.style), m),
    className: H,
    prefixCls: M,
    direction: s,
    defaultMotions: B,
    expandIcon: X,
    ref: n,
    rootClassName: V(w, k, r.rootClassName, R, N),
    _internalComponents: qi
  })))));
}), ke = /* @__PURE__ */ bt((e, n) => {
  const t = De(null), o = i.useContext(en);
  return kn(n, () => ({
    menu: t.current,
    focus: (r) => {
      var l;
      (l = t.current) === null || l === void 0 || l.focus(r);
    }
  })), /* @__PURE__ */ i.createElement(Ui, Object.assign({
    ref: t
  }, e, o));
});
ke.Item = mo;
ke.SubMenu = po;
ke.Divider = uo;
ke.ItemGroup = St;
process.env.NODE_ENV !== "production" && (ke.displayName = "Menu");
const Yi = (e) => {
  const {
    componentCls: n,
    menuCls: t,
    colorError: o,
    colorTextLightSolid: r
  } = e, l = `${t}-item`;
  return {
    [`${n}, ${n}-menu-submenu`]: {
      [`${t} ${l}`]: {
        [`&${l}-danger:not(${l}-disabled)`]: {
          color: o,
          "&:hover": {
            color: r,
            backgroundColor: o
          }
        }
      }
    }
  };
}, Zi = (e) => {
  const {
    componentCls: n,
    menuCls: t,
    zIndexPopup: o,
    dropdownArrowDistance: r,
    sizePopupArrow: l,
    antCls: a,
    iconCls: s,
    motionDurationMid: c,
    paddingBlock: u,
    fontSize: f,
    dropdownEdgeChildPadding: d,
    colorTextDisabled: m,
    fontSizeIcon: g,
    controlPaddingHorizontal: p,
    colorBgElevated: v
  } = e;
  return [
    {
      [n]: {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: o,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: e.calc(l).div(2).sub(r).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
        "&-menu-vertical": {
          maxHeight: "100vh",
          overflowY: "auto"
        },
        [`&-trigger${a}-btn`]: {
          [`& > ${s}-down, & > ${a}-btn-icon > ${s}-down`]: {
            fontSize: g
          }
        },
        [`${n}-wrap`]: {
          position: "relative",
          [`${a}-btn > ${s}-down`]: {
            fontSize: g
          },
          [`${s}-down::before`]: {
            transition: `transform ${c}`
          }
        },
        [`${n}-wrap-open`]: {
          [`${s}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ": {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${a}-slide-down-enter${a}-slide-down-enter-active${n}-placement-bottomLeft,
          &${a}-slide-down-appear${a}-slide-down-appear-active${n}-placement-bottomLeft,
          &${a}-slide-down-enter${a}-slide-down-enter-active${n}-placement-bottom,
          &${a}-slide-down-appear${a}-slide-down-appear-active${n}-placement-bottom,
          &${a}-slide-down-enter${a}-slide-down-enter-active${n}-placement-bottomRight,
          &${a}-slide-down-appear${a}-slide-down-appear-active${n}-placement-bottomRight`]: {
          animationName: Sr
        },
        [`&${a}-slide-up-enter${a}-slide-up-enter-active${n}-placement-topLeft,
          &${a}-slide-up-appear${a}-slide-up-appear-active${n}-placement-topLeft,
          &${a}-slide-up-enter${a}-slide-up-enter-active${n}-placement-top,
          &${a}-slide-up-appear${a}-slide-up-appear-active${n}-placement-top,
          &${a}-slide-up-enter${a}-slide-up-enter-active${n}-placement-topRight,
          &${a}-slide-up-appear${a}-slide-up-appear-active${n}-placement-topRight`]: {
          animationName: xr
        },
        [`&${a}-slide-down-leave${a}-slide-down-leave-active${n}-placement-bottomLeft,
          &${a}-slide-down-leave${a}-slide-down-leave-active${n}-placement-bottom,
          &${a}-slide-down-leave${a}-slide-down-leave-active${n}-placement-bottomRight`]: {
          animationName: wr
        },
        [`&${a}-slide-up-leave${a}-slide-up-leave-active${n}-placement-topLeft,
          &${a}-slide-up-leave${a}-slide-up-leave-active${n}-placement-top,
          &${a}-slide-up-leave${a}-slide-up-leave-active${n}-placement-topRight`]: {
          animationName: Er
        }
      }
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    fr(e, v, {
      arrowPlacement: {
        top: !0,
        bottom: !0
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${n} ${t}`]: {
        position: "relative",
        margin: 0
      },
      [`${t}-submenu-popup`]: {
        position: "absolute",
        zIndex: o,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${n}, ${n}-menu-submenu`]: Object.assign(Object.assign({}, Kn(e)), {
        [t]: Object.assign(Object.assign({
          padding: d,
          listStyleType: "none",
          backgroundColor: v,
          backgroundClip: "padding-box",
          borderRadius: e.borderRadiusLG,
          outline: "none",
          boxShadow: e.boxShadowSecondary
        }, In(e)), {
          "&:empty": {
            padding: 0,
            boxShadow: "none"
          },
          [`${t}-item-group-title`]: {
            padding: `${_(u)} ${_(p)}`,
            color: e.colorTextDescription,
            transition: `all ${c}`
          },
          // ======================= Item Content =======================
          [`${t}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${t}-item-icon`]: {
            minWidth: f,
            marginInlineEnd: e.marginXS,
            fontSize: e.fontSizeSM
          },
          [`${t}-title-content`]: {
            flex: "auto",
            "&-with-extra": {
              display: "inline-flex",
              alignItems: "center",
              width: "100%"
            },
            "> a": {
              color: "inherit",
              transition: `all ${c}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            },
            [`${t}-item-extra`]: {
              paddingInlineStart: e.padding,
              marginInlineStart: "auto",
              fontSize: e.fontSizeSM,
              color: e.colorTextDescription
            }
          },
          // =========================== Item ===========================
          [`${t}-item, ${t}-submenu-title`]: Object.assign(Object.assign({
            display: "flex",
            margin: 0,
            padding: `${_(u)} ${_(p)}`,
            color: e.colorText,
            fontWeight: "normal",
            fontSize: f,
            lineHeight: e.lineHeight,
            cursor: "pointer",
            transition: `all ${c}`,
            borderRadius: e.borderRadiusSM,
            "&:hover, &-active": {
              backgroundColor: e.controlItemBgHover
            }
          }, In(e)), {
            "&-selected": {
              color: e.colorPrimary,
              backgroundColor: e.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: e.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: m,
              cursor: "not-allowed",
              "&:hover": {
                color: m,
                backgroundColor: v,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${_(e.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: e.colorSplit
            },
            [`${n}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: e.paddingXS,
              [`${n}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: e.colorIcon,
                fontSize: g,
                fontStyle: "normal"
              }
            }
          }),
          [`${t}-item-group-list`]: {
            margin: `0 ${_(e.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${t}-submenu-title`]: {
            paddingInlineEnd: e.calc(p).add(e.fontSizeSM).equal()
          },
          [`${t}-submenu-vertical`]: {
            position: "relative"
          },
          [`${t}-submenu${t}-submenu-disabled ${n}-menu-submenu-title`]: {
            [`&, ${n}-menu-submenu-arrow-icon`]: {
              color: m,
              backgroundColor: v,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${t}-submenu-selected ${n}-menu-submenu-title`]: {
            color: e.colorPrimary
          }
        })
      })
    },
    // Follow code may reuse in other components
    [ut(e, "slide-up"), ut(e, "slide-down"), Sn(e, "move-up"), Sn(e, "move-down"), Un(e, "zoom-big")]
  ];
}, Qi = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 50,
  paddingBlock: (e.controlHeight - e.fontSize * e.lineHeight) / 2
}, vr({
  contentRadius: e.borderRadiusLG,
  limitVerticalRadius: !0
})), dr(e)), Ji = $t("Dropdown", (e) => {
  const {
    marginXXS: n,
    sizePopupArrow: t,
    paddingXXS: o,
    componentCls: r
  } = e, l = Ht(e, {
    menuCls: `${r}-menu`,
    dropdownArrowDistance: e.calc(t).div(2).add(n).equal(),
    dropdownEdgeChildPadding: o
  });
  return [Zi(l), Yi(l)];
}, Qi, {
  resetStyle: !1
}), tt = (e) => {
  var n;
  const {
    menu: t,
    arrow: o,
    prefixCls: r,
    children: l,
    trigger: a,
    disabled: s,
    dropdownRender: c,
    popupRender: u,
    getPopupContainer: f,
    overlayClassName: d,
    rootClassName: m,
    overlayStyle: g,
    open: p,
    onOpenChange: v,
    // Deprecated
    visible: h,
    onVisibleChange: y,
    mouseEnterDelay: w = 0.15,
    mouseLeaveDelay: $ = 0.1,
    autoAdjustOverflow: I = !0,
    placement: b = "",
    overlay: S,
    transitionName: x,
    destroyOnHidden: E,
    destroyPopupOnHide: C
  } = e, {
    getPopupContainer: O,
    getPrefixCls: T,
    direction: P,
    dropdown: B
  } = i.useContext(Qe), M = u || c, N = Xn("Dropdown");
  process.env.NODE_ENV !== "production" && (Object.entries({
    visible: "open",
    onVisibleChange: "onOpenChange",
    overlay: "menu",
    dropdownRender: "popupRender",
    destroyPopupOnHide: "destroyOnHidden"
  }).forEach(([ue, Me]) => {
    N.deprecated(!(ue in e), ue, Me);
  }), b.includes("Center") && N.deprecated(!b.includes("Center"), `placement: ${b}`, `placement: ${b.slice(0, b.indexOf("Center"))}`));
  const A = i.useMemo(() => {
    const U = T();
    return x !== void 0 ? x : b.includes("top") ? `${U}-slide-down` : `${U}-slide-up`;
  }, [T, b, x]), k = i.useMemo(() => b ? b.includes("Center") ? b.slice(0, b.indexOf("Center")) : b : P === "rtl" ? "bottomRight" : "bottomLeft", [b, P]), R = T("dropdown", r), H = qn(R), [X, ee, W] = Ji(R, H), [, z] = cr(), F = i.Children.only(Wr(l) ? /* @__PURE__ */ i.createElement("span", null, l) : l), L = Ct(F, {
    className: V(`${R}-trigger`, {
      [`${R}-rtl`]: P === "rtl"
    }, F.props.className),
    disabled: (n = F.props.disabled) !== null && n !== void 0 ? n : s
  }), j = s ? [] : a, Z = !!(j != null && j.includes("contextMenu")), [D, G] = Ue(!1, {
    value: p ?? h
  }), Q = Vn((U) => {
    v == null || v(U, {
      source: "trigger"
    }), y == null || y(U), G(U);
  }), ne = V(d, m, ee, W, H, B == null ? void 0 : B.className, {
    [`${R}-rtl`]: P === "rtl"
  }), pe = gr({
    arrowPointAtCenter: typeof o == "object" && o.pointAtCenter,
    autoAdjustOverflow: I,
    offset: z.marginXXS,
    arrowWidth: o ? z.sizePopupArrow : 0,
    borderRadius: z.borderRadius
  }), Oe = i.useCallback(() => {
    t != null && t.selectable && (t != null && t.multiple) || (v == null || v(!1, {
      source: "menu"
    }), G(!1));
  }, [t == null ? void 0 : t.selectable, t == null ? void 0 : t.multiple]), he = () => {
    let U;
    return t != null && t.items ? U = /* @__PURE__ */ i.createElement(ke, Object.assign({}, t)) : typeof S == "function" ? U = S() : U = S, M && (U = M(U)), U = i.Children.only(typeof U == "string" ? /* @__PURE__ */ i.createElement("span", null, U) : U), /* @__PURE__ */ i.createElement(Li, {
      prefixCls: `${R}-menu`,
      rootClassName: V(W, H),
      expandIcon: /* @__PURE__ */ i.createElement("span", {
        className: `${R}-menu-submenu-arrow`
      }, P === "rtl" ? /* @__PURE__ */ i.createElement(pt, {
        className: `${R}-menu-submenu-arrow-icon`
      }) : /* @__PURE__ */ i.createElement(mt, {
        className: `${R}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: !1,
      onClick: Oe,
      validator: ({
        mode: ue
      }) => {
        process.env.NODE_ENV !== "production" && N(!ue || ue === "vertical", "usage", `mode="${ue}" is not supported for Dropdown's Menu.`);
      }
    }, U);
  }, [ge, He] = Fn("Dropdown", g == null ? void 0 : g.zIndex);
  let ye = /* @__PURE__ */ i.createElement(Vr, Object.assign({
    alignPoint: Z
  }, Ce(e, ["rootClassName"]), {
    mouseEnterDelay: w,
    mouseLeaveDelay: $,
    visible: D,
    builtinPlacements: pe,
    arrow: !!o,
    overlayClassName: ne,
    prefixCls: R,
    getPopupContainer: f || O,
    transitionName: A,
    trigger: j,
    overlay: he,
    placement: k,
    onVisibleChange: Q,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, B == null ? void 0 : B.style), g), {
      zIndex: ge
    }),
    autoDestroy: E ?? C
  }), L);
  return ge && (ye = /* @__PURE__ */ i.createElement(mr.Provider, {
    value: He
  }, ye)), X(ye);
}, ea = br(tt, "align", void 0, "dropdown", (e) => e), ta = (e) => /* @__PURE__ */ i.createElement(ea, Object.assign({}, e), /* @__PURE__ */ i.createElement("span", null));
tt._InternalPanelDoNotUseOrYouWillBeFired = ta;
process.env.NODE_ENV !== "production" && (tt.displayName = "Dropdown");
function zn(e) {
  return ["small", "middle", "large"].includes(e);
}
function An(e) {
  return e ? typeof e == "number" && !Number.isNaN(e) : !1;
}
const fo = /* @__PURE__ */ oe.createContext({
  latestIndex: 0
}), na = fo.Provider, oa = ({
  className: e,
  index: n,
  children: t,
  split: o,
  style: r
}) => {
  const {
    latestIndex: l
  } = i.useContext(fo);
  return t == null ? null : /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement("div", {
    className: e,
    style: r
  }, t), n < l && o && /* @__PURE__ */ i.createElement("span", {
    className: `${e}-split`
  }, o));
};
var ra = function(e, n) {
  var t = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (t[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
    n.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (t[o[r]] = e[o[r]]);
  return t;
};
const ia = /* @__PURE__ */ i.forwardRef((e, n) => {
  var t;
  const {
    getPrefixCls: o,
    direction: r,
    size: l,
    className: a,
    style: s,
    classNames: c,
    styles: u
  } = ur("space"), {
    size: f = l ?? "small",
    align: d,
    className: m,
    rootClassName: g,
    children: p,
    direction: v = "horizontal",
    prefixCls: h,
    split: y,
    style: w,
    wrap: $ = !1,
    classNames: I,
    styles: b
  } = e, S = ra(e, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [x, E] = Array.isArray(f) ? f : [f, f], C = zn(E), O = zn(x), T = An(E), P = An(x), B = Gt(p, {
    keepEmpty: !0
  }), M = d === void 0 && v === "horizontal" ? "center" : d, N = o("space", h), [A, k, R] = yr(N), H = V(N, a, k, `${N}-${v}`, {
    [`${N}-rtl`]: r === "rtl",
    [`${N}-align-${M}`]: M,
    [`${N}-gap-row-${E}`]: C,
    [`${N}-gap-col-${x}`]: O
  }, m, g, R), X = V(`${N}-item`, (t = I == null ? void 0 : I.item) !== null && t !== void 0 ? t : c.item);
  let ee = 0;
  const W = B.map((L, j) => {
    var Z;
    L != null && (ee = j);
    const D = (L == null ? void 0 : L.key) || `${X}-${j}`;
    return /* @__PURE__ */ i.createElement(oa, {
      className: X,
      key: D,
      index: j,
      split: y,
      style: (Z = b == null ? void 0 : b.item) !== null && Z !== void 0 ? Z : u.item
    }, L);
  }), z = i.useMemo(() => ({
    latestIndex: ee
  }), [ee]);
  if (B.length === 0)
    return null;
  const F = {};
  return $ && (F.flexWrap = "wrap"), !O && P && (F.columnGap = x), !C && T && (F.rowGap = E), A(/* @__PURE__ */ i.createElement("div", Object.assign({
    ref: n,
    className: H,
    style: Object.assign(Object.assign(Object.assign({}, F), s), w)
  }, S), /* @__PURE__ */ i.createElement(na, {
    value: z
  }, W)));
}), nn = ia;
nn.Compact = Cr;
process.env.NODE_ENV !== "production" && (nn.displayName = "Space");
var aa = function(e, n) {
  var t = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (t[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
    n.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (t[o[r]] = e[o[r]]);
  return t;
};
const vo = (e) => {
  const {
    getPopupContainer: n,
    getPrefixCls: t,
    direction: o
  } = i.useContext(Qe), {
    prefixCls: r,
    type: l = "default",
    danger: a,
    disabled: s,
    loading: c,
    onClick: u,
    htmlType: f,
    children: d,
    className: m,
    menu: g,
    arrow: p,
    autoFocus: v,
    overlay: h,
    trigger: y,
    align: w,
    open: $,
    onOpenChange: I,
    placement: b,
    getPopupContainer: S,
    href: x,
    icon: E = /* @__PURE__ */ i.createElement(tn, null),
    title: C,
    buttonsRender: O = (ne) => ne,
    mouseEnterDelay: T,
    mouseLeaveDelay: P,
    overlayClassName: B,
    overlayStyle: M,
    destroyOnHidden: N,
    destroyPopupOnHide: A,
    dropdownRender: k,
    popupRender: R
  } = e, H = aa(e, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyOnHidden", "destroyPopupOnHide", "dropdownRender", "popupRender"]), X = t("dropdown", r), ee = `${X}-button`, z = {
    menu: g,
    arrow: p,
    autoFocus: v,
    align: w,
    disabled: s,
    trigger: s ? [] : y,
    onOpenChange: I,
    getPopupContainer: S || n,
    mouseEnterDelay: T,
    mouseLeaveDelay: P,
    overlayClassName: B,
    overlayStyle: M,
    destroyOnHidden: N,
    popupRender: R || k
  }, {
    compactSize: F,
    compactItemClassnames: L
  } = Ir(X, o), j = V(ee, L, m);
  "destroyPopupOnHide" in e && (z.destroyPopupOnHide = A), "overlay" in e && (z.overlay = h), "open" in e && (z.open = $), "placement" in e ? z.placement = b : z.placement = o === "rtl" ? "bottomLeft" : "bottomRight";
  const Z = /* @__PURE__ */ i.createElement(dt, {
    type: l,
    danger: a,
    disabled: s,
    loading: c,
    onClick: u,
    htmlType: f,
    href: x,
    title: C
  }, d), D = /* @__PURE__ */ i.createElement(dt, {
    type: l,
    danger: a,
    icon: E
  }), [G, Q] = O([Z, D]);
  return /* @__PURE__ */ i.createElement(nn.Compact, Object.assign({
    className: j,
    size: F,
    block: !0
  }, H), G, /* @__PURE__ */ i.createElement(tt, Object.assign({}, z), Q));
};
vo.__ANT_BUTTON = !0;
const go = tt;
go.Button = vo;
const la = {
  primary: {
    color: "primary"
  },
  secondary: {
    color: "default"
  },
  danger: {
    color: "danger"
  }
}, sa = {
  sm: "small",
  md: "middle",
  lg: "large"
}, ca = (e) => Zo(e) ? { ...e, position: e.position ?? "start" } : { position: "start", icon: e }, Aa = bt(
  ({
    variant: e = "solid",
    appearance: n = "primary",
    size: t = "md",
    shape: o = "default",
    icon: r,
    type: l = "button",
    label: a,
    children: s,
    onClick: c,
    loading: u,
    menu: f,
    ...d
  }, m) => {
    var x;
    const [g, p] = kt(!1), { position: v, icon: h } = ca(r), y = la[n], w = Uo(), $ = async (E) => {
      if (c)
        try {
          const C = c(E);
          return C && typeof C.then == "function" ? (p(!0), await C) : C;
        } finally {
          w.current && p(!1);
        }
    }, I = u !== void 0 ? u : g, b = {
      icon: /* @__PURE__ */ _t(Yo, {}),
      trigger: ["click"],
      ...f || { items: [] }
    }, S = {
      size: sa[t],
      onClick: $,
      loading: I
    };
    if ((x = b.items) != null && x.length) {
      const {
        items: E,
        trigger: C,
        placement: O,
        icon: T,
        disabled: P,
        loading: B
      } = b, M = {
        solid: "primary",
        outlined: "default",
        text: "text"
      };
      return /* @__PURE__ */ _t(
        go.Button,
        {
          style: { width: "auto" },
          danger: n === "danger",
          menu: {
            items: E
          },
          placement: O,
          trigger: C,
          type: M[e],
          ...S,
          ...d,
          ...y,
          children: s ?? a,
          buttonsRender: ([N, A]) => [
            oe.isValidElement(N) ? oe.cloneElement(N, {
              icon: h
            }) : N,
            oe.isValidElement(A) ? oe.cloneElement(A, {
              icon: T,
              disabled: P,
              loading: B
            }) : A
          ]
        }
      );
    }
    return /* @__PURE__ */ _t(
      dt,
      {
        ...S,
        variant: e,
        icon: h,
        ref: m,
        shape: o,
        iconPosition: v,
        htmlType: l,
        ...d,
        ...y,
        children: s ?? a
      }
    );
  }
), ka = dt.Group;
export {
  Aa as B,
  Vr as D,
  et as E,
  It as M,
  Li as O,
  tn as R,
  ka as a,
  go as b,
  mt as c,
  pt as d,
  ke as e,
  ca as p
};
